
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("eleJt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e06dbaa034d71153$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kJlBc = parcelRequire("kJlBc");

var $frZnw = parcelRequire("frZnw");

var $1OI0B = parcelRequire("1OI0B");

var $ek16G = parcelRequire("ek16G");

var $hxkny = parcelRequire("hxkny");

const $e06dbaa034d71153$var$KnowledgeHubCategoryApp = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("fgAHK")), {
    moduleId: "./src/packages/servicedesk/knowledge-hub-category/src/index.tsx"
});
const $e06dbaa034d71153$var$View = ()=>{
    const [{ match: matchRouter }] = (0, $kJlBc.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hxkny.KnowledgeHubAppBase), {
        appName: (0, $frZnw.APP_NAMES).KB_CATEGORY
    }, ({ projectId: projectId, projectKey: projectKey, locale: locale, activationId: activationId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1OI0B.KnowledgeBaseBreadcrumb), {
            projectKey: projectKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e06dbaa034d71153$var$KnowledgeHubCategoryApp, {
            projectId: projectId,
            projectKey: projectKey,
            categoryId: (0, $ek16G.toCategoryGuid)(matchRouter.params?.categoryId || ''),
            locale: locale,
            activationId: activationId
        })));
};
var $e06dbaa034d71153$export$2e2bcd8739ae039 = $e06dbaa034d71153$var$View;

});
parcelRegister("1OI0B", function(module, exports) {

$parcel$export(module.exports, "KnowledgeBaseBreadcrumb", () => $817e45378b32094d$export$f2521acff636c885);

var $eUqFw = parcelRequire("eUqFw");

var $kKe2o = parcelRequire("kKe2o");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bsXHw = parcelRequire("bsXHw");
const $817e45378b32094d$export$f2521acff636c885 = ({ projectKey: projectKey, children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const constructHref = ()=>(0, $1ybV0.ff)('jsm-kb-nav-refresh-changes-enabled') && window.location.href.includes('/categories') ? `/jira/servicedesk/projects/${projectKey}/knowledge/categories` : `/jira/servicedesk/projects/${projectKey}/knowledge`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            href: constructHref(),
            text: formatMessage((0, $bsXHw.default).knowledgeBase),
            type: 'jsd-knowledge-base'
        }
    }, children);
};
var $817e45378b32094d$export$2e2bcd8739ae039 = $817e45378b32094d$export$f2521acff636c885;

});
parcelRegister("bsXHw", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c1730bf8990970$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $79c1730bf8990970$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    knowledgeBase: {
        "id": "servicedesk-knowledge-common.knowledge-hub-breadcrumb.knowledge-base",
        "defaultMessage": "Knowledge base"
    }
});

});


parcelRegister("ek16G", function(module, exports) {

$parcel$export(module.exports, "categoryGuidToString", () => $0546f5715765b38a$export$43162cfd3260b2fe);
$parcel$export(module.exports, "toCategoryGuid", () => $0546f5715765b38a$export$be5c80c4ad1faf99);
const $0546f5715765b38a$export$43162cfd3260b2fe = (guid)=>guid;
const $0546f5715765b38a$export$be5c80c4ad1faf99 = (guid)=>guid;

});

parcelRegister("hxkny", function(module, exports) {

$parcel$export(module.exports, "KnowledgeHubAppBase", () => $b0d76b58295a0ff2$export$f848f52481042e56);

var $eUqFw = parcelRequire("eUqFw");

var $9c7gV = parcelRequire("9c7gV");

var $7ehAr = parcelRequire("7ehAr");
var $dpXKE = parcelRequire("dpXKE");

var $ae4LH = parcelRequire("ae4LH");

var $1ybV0 = parcelRequire("1ybV0");

var $kKzsy = parcelRequire("kKzsy");

var $hnWvl = parcelRequire("hnWvl");

var $3o0h6 = parcelRequire("3o0h6");
var $2RidI = parcelRequire("2RidI");
var $2d7Sj = parcelRequire("2d7Sj");
var $51Ia6 = parcelRequire("51Ia6");
const $b0d76b58295a0ff2$export$f848f52481042e56 = (props)=>{
    const { appName: appName, shouldRemoveMargin: shouldRemoveMargin = false } = props;
    const [{ data: pageContextData, error: pageContextError }] = (0, $51Ia6.usePageContext)();
    const { projectContext: projectContext, tenantContext: tenantContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName } = projectContext || {};
    const { locale: locale, activationId: activationId } = tenantContext || {};
    const { projectId: projectId } = projectContext || {};
    const { portalId: portalId } = serviceDeskContext || {};
    // Pagecontext has not loaded
    if (!pageContextData && !pageContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    const CustomizedPageStyle = (0, $1ybV0.ff)('jsm-kb-nav-refresh-changes-enabled') && shouldRemoveMargin ? (0, $9c7gV.default) : (0, $3o0h6.PageStyle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RidI.default), {
        appName: appName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.ServiceDeskDocumentTitle), {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        projectName: projectName,
        section: "knowledge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnWvl.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: "",
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        projectKey: projectKey,
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomizedPageStyle, null, props.children({
        projectKey: projectKey,
        projectId: projectId,
        portalId: portalId,
        locale: locale,
        activationId: activationId
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelShouldRender), null));
};
var $b0d76b58295a0ff2$export$2e2bcd8739ae039 = $b0d76b58295a0ff2$export$f848f52481042e56;

});
parcelRegister("9c7gV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be3daaa307b075d$export$2e2bcd8739ae039);

var $aJWi0 = parcelRequire("aJWi0");

var $j7bQJ = parcelRequire("j7bQJ");

var $6tahE = parcelRequire("6tahE");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$4be3daaa307b075d$export$2e2bcd8739ae039 = (0, $aJWi0.default);

});
parcelRegister("aJWi0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7341c6e5fd381e79$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");
function $7341c6e5fd381e79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7341c6e5fd381e79$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $7341c6e5fd381e79$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $7341c6e5fd381e79$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $7341c6e5fd381e79$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $7341c6e5fd381e79$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $7341c6e5fd381e79$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $7341c6e5fd381e79$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $cuCEk.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$pageContentStyles
    }, children)));
};
var $7341c6e5fd381e79$export$2e2bcd8739ae039 = $7341c6e5fd381e79$var$Page;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});



parcelRegister("kKzsy", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $993d872dc7228c2f$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $993d872dc7228c2f$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $993d872dc7228c2f$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $993d872dc7228c2f$export$c7732c55900cf0b9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hfiyN")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hTkS8")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("c3XjM")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("eTjqX")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $993d872dc7228c2f$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender, null));
$993d872dc7228c2f$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $993d872dc7228c2f$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanel, null));
$993d872dc7228c2f$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $993d872dc7228c2f$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton, null));
$993d872dc7228c2f$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $993d872dc7228c2f$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight, null));
$993d872dc7228c2f$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("hfiyN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kd6Ju');
        const value = parcelRequire('appSk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kd6Ju").then(()=>parcelRequire('appSk'));
}

});

parcelRegister("hTkS8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('5eFqM')
        ]);
        const value = parcelRequire('ddfk6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("5eFqM")
    ]).then(()=>parcelRequire('ddfk6'));
}

});

parcelRegister("c3XjM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('ahRif')
        ]);
        const value = parcelRequire('1HvEW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("ahRif")
    ]).then(()=>parcelRequire('1HvEW'));
}

});

parcelRegister("eTjqX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('cxrYi')
        ]);
        const value = parcelRequire('f9sDQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("cxrYi")
    ]).then(()=>parcelRequire('f9sDQ'));
}

});


parcelRegister("hnWvl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4474a3c1b32a9c15$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6bxa8 = parcelRequire("6bxa8");

var $79HyS = parcelRequire("79HyS");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4474a3c1b32a9c15$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $79HyS.default), null, ({ isOpen: isOpen, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6bxa8.default), {
            isOpen: isOpen,
            onClose: onClose
        }));

});
parcelRegister("6bxa8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a60f60e96f41217a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $dxopF = parcelRequire("dxopF");


var $kJlBc = parcelRequire("kJlBc");

var $eZfBZ = parcelRequire("eZfBZ");

var $51Ia6 = parcelRequire("51Ia6");

var $ek16G = parcelRequire("ek16G");

var $kKcMO = parcelRequire("kKcMO");

var $aqS7I = parcelRequire("aqS7I");
const $a60f60e96f41217a$var$KnowledgeHubCreateCategory = (props)=>{
    const { isOpen: isOpen, onClose: onClose } = props;
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const [{ data: pageContextData }] = (0, $51Ia6.usePageContext)();
    const { projectContext: projectContext, tenantContext: tenantContext } = pageContextData || {};
    const { projectId: projectId, projectKey: projectKey } = projectContext || {};
    const [{ isSubmitting: isSubmitting, formValues: formValues, error: error, createdCategory: createdCategory }, { createCategory: createCategory, handleFormInputChange: handleFormInputChange, resetCreatedCategory: resetCreatedCategory }] = (0, $kKcMO.useCreateCategoryData)();
    const activationId = tenantContext?.activationId || '';
    const isValid = !!formValues.name && formValues.name.length !== 0;
    const onChange = (field, value)=>{
        handleFormInputChange(field, value);
    };
    (0, $eUqFw.useEffect)(()=>{
        if (!createdCategory) return;
        onClose();
        resetCreatedCategory();
        push(`/jira/servicedesk/projects/${projectKey}/knowledge/categories/${(0, $ek16G.categoryGuidToString)(createdCategory.id)}`);
    }, [
        createdCategory,
        projectKey,
        push,
        onClose,
        resetCreatedCategory
    ]);
    const onSubmit = (e, analyticsEvent)=>{
        e.preventDefault();
        if (isSubmitting || !isValid) return;
        projectId && createCategory(projectId, analyticsEvent, activationId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            source: `knowledgeCreateCategory${(0, $41ea3621645e2acc$export$1171103ea9083ffa)}`,
            actionSubject: 'category',
            attributes: {
                context: (0, $eZfBZ.ANALYTIC_CONTEXTS).KNOWLEDGE
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqS7I.default), {
        onChange: onChange,
        onClose: onClose,
        onSubmit: onSubmit,
        formValues: formValues,
        formError: error.formError,
        fieldErrors: error.fieldErrors,
        isSubmitting: isSubmitting,
        isDisabled: !isValid
    })));
};
var $a60f60e96f41217a$export$2e2bcd8739ae039 = $a60f60e96f41217a$var$KnowledgeHubCreateCategory;

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("eZfBZ", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_CONTEXTS", () => $6d93f232242cadb5$export$ca021921d5c56515);
$parcel$export(module.exports, "ttiRecommendedSlo", () => $6d93f232242cadb5$export$dc391c7d81907d3a);
$parcel$export(module.exports, "trackJsdFetchErrors", () => $6d93f232242cadb5$export$ebdbd98df5a27905);
$parcel$export(module.exports, "fireJsonOnlyErrorAnalytics", () => $6d93f232242cadb5$export$32233c6edb041cf2);

var $guiFP = parcelRequire("guiFP");

var $fV97Z = parcelRequire("fV97Z");
const $6d93f232242cadb5$export$ca021921d5c56515 = {
    AUTOMATION_SETTINGS: 'AutomationSettings',
    KNOWLEDGE: 'Knowledge',
    QUEUES: 'Queues',
    CSAT: 'Csat'
};
const $6d93f232242cadb5$export$cca3c4e11cb0a5ce = 1000;
const $6d93f232242cadb5$export$dc391c7d81907d3a = 4000;
const $6d93f232242cadb5$export$ebdbd98df5a27905 = async (payload)=>{
    const { error: error, attributes: attributes } = payload;
    if (error instanceof (0, $fV97Z.JsdFetchError)) {
        const { reasonKey: reasonKey } = error;
        (0, $guiFP.trackFetchErrors)({
            ...payload,
            attributes: {
                ...attributes,
                reasonKey: reasonKey
            }
        });
        return;
    }
    (0, $guiFP.trackFetchErrors)(payload);
};
function $6d93f232242cadb5$export$32233c6edb041cf2({ error: error, ...rest }) {
    let useError = false;
    if (error instanceof Error) try {
        JSON.parse(error.message);
        useError = true;
    } catch (e) {
        useError = false;
    }
    (0, $guiFP.default)({
        error: error instanceof Error && useError ? error : undefined,
        ...rest
    });
}

});
parcelRegister("fV97Z", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $c9869c00ba1fbd5b$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $c9869c00ba1fbd5b$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $c9869c00ba1fbd5b$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $c9869c00ba1fbd5b$export$8ef51cba9d28f819);

var $8blac = parcelRequire("8blac");

var $kkgbD = parcelRequire("kkgbD");

var $fVqUX = parcelRequire("fVqUX");


var $7EhAs = parcelRequire("7EhAs");

var $88Osm = parcelRequire("88Osm");

var $lRmyA = parcelRequire("lRmyA");
const $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY = 'validation.error';
class $c9869c00ba1fbd5b$export$fee0012ae6cb3438 extends (0, $7EhAs.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(response)) this.response = response;
    }
}
const $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $c9869c00ba1fbd5b$var$putOptions = {
    ...(0, $fVqUX.default),
    method: 'PUT'
};
const $c9869c00ba1fbd5b$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $c9869c00ba1fbd5b$var$deleteOptions = {
    ...(0, $fVqUX.default),
    method: 'DELETE'
};
const $c9869c00ba1fbd5b$var$patchOptions = {
    ...(0, $fVqUX.default),
    method: 'PATCH'
};
const $c9869c00ba1fbd5b$var$processResponse = async (response)=>{
    if ((0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY) throw (0, $lRmyA.transformValidationErrorFromServer)(jsonResponse);
        const message = $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer(errors);
        throw new $c9869c00ba1fbd5b$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $7EhAs.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $7EhAs.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $fVqUX.default),
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$putOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$postOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$deleteOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$patchOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;



parcelRegister("51Ia6", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $16ae5fc48efca0d6$export$9c25024bdfe755f7);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ixwgj = parcelRequire("ixwgj");

var $gd0Sp = parcelRequire("gd0Sp");

var $jyTef = parcelRequire("jyTef");
const $16ae5fc48efca0d6$var$getProjectContextResource = ()=>(0, $ixwgj.projectContextResourceWithCache);
const $16ae5fc48efca0d6$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $iZJHG.useResourceWithCustomRouterContext)($16ae5fc48efca0d6$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $jyTef.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $eUqFw.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("jyTef", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $3f940b317a874b53$export$712ead87353ac687);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ct0sQ = parcelRequire("ct0sQ");

var $9V785 = parcelRequire("9V785");
const $3f940b317a874b53$var$getServiceDeskContextResource = ()=>(0, $ct0sQ.serviceDeskContextResource);
const $3f940b317a874b53$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $iZJHG.useResourceWithCustomRouterContext)($3f940b317a874b53$var$getServiceDeskContextResource(), customContext);
    (0, $eUqFw.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});
parcelRegister("9V785", function(module, exports) {

$parcel$export(module.exports, "USER_JSM_PROJECT_ROLE", () => $3cdacd90d2ecef12$export$a9054e41660c4d00);
// use USER_JSM_PROJECT_ROLE instead
const $3cdacd90d2ecef12$var$AGENT_ROLE = 'agent';
const $3cdacd90d2ecef12$var$AGENT_PROJECT_ADMIN_ROLE = 'agent-project-admin';
const $3cdacd90d2ecef12$var$JIRA_ROLE = 'jira-user';
const $3cdacd90d2ecef12$export$a9054e41660c4d00 = {
    AGENT_ROLE: $3cdacd90d2ecef12$var$AGENT_ROLE,
    AGENT_PROJECT_ADMIN_ROLE: $3cdacd90d2ecef12$var$AGENT_PROJECT_ADMIN_ROLE,
    JIRA_ROLE: $3cdacd90d2ecef12$var$JIRA_ROLE
};

});



parcelRegister("kKcMO", function(module, exports) {

$parcel$export(module.exports, "initialCreateCategoryData", () => $d40b22709becaf61$export$4947e9942a5d137c);
$parcel$export(module.exports, "KnowledgeCommonSubscriber", () => $d40b22709becaf61$export$d226f0c95b79366b);
$parcel$export(module.exports, "UserCapabilitiesSubscriber", () => $d40b22709becaf61$export$42b7b5df8c1dee52);
$parcel$export(module.exports, "useFlagData", () => $d40b22709becaf61$export$a9ac4a6dcb7104bf);
$parcel$export(module.exports, "useGetCategory", () => $d40b22709becaf61$export$3fa52226f8fff61e);
$parcel$export(module.exports, "useDraftShareId", () => $d40b22709becaf61$export$2602997fd4d9b312);
$parcel$export(module.exports, "useArticleId", () => $d40b22709becaf61$export$a5eb46485735066a);
$parcel$export(module.exports, "useIsFetchingDraftDetails", () => $d40b22709becaf61$export$428db75bed41f9d);
$parcel$export(module.exports, "useRedirectionData", () => $d40b22709becaf61$export$e30071c464cba7f9);
$parcel$export(module.exports, "useUserCapabilities", () => $d40b22709becaf61$export$7ae10e817e068c57);
$parcel$export(module.exports, "useIsPermittedSpaces", () => $d40b22709becaf61$export$60270d772f1f3c76);
$parcel$export(module.exports, "useCategoriesData", () => $d40b22709becaf61$export$56b47c5ebac10997);
$parcel$export(module.exports, "useCreateCategoryData", () => $d40b22709becaf61$export$1e7300097c003415);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $3RIBa = parcelRequire("3RIBa");

var $iTtA0 = parcelRequire("iTtA0");
const $d40b22709becaf61$export$61e797cf03b496e1 = {
    hasConfluenceLicense: false,
    articleUserCapabilities: {
        canCreateArticle: false
    },
    spaceUserCapabilities: {
        editableSpaces: [],
        readableSpaces: []
    }
};
const $d40b22709becaf61$export$4947e9942a5d137c = {
    isSubmitting: false,
    formValues: {
        name: '',
        description: ''
    },
    error: {
        formError: undefined,
        fieldErrors: undefined
    },
    createdCategory: null
};
const $d40b22709becaf61$export$d4c72bab9d6cc13a = {
    draftShareId: '',
    articleId: '',
    published: false,
    closed: false,
    deleted: false,
    redirectionData: {
        onPublishRedirectUrl: '',
        onCloseRedirectUrl: ''
    },
    isFetchingDraftDetails: false,
    spacesPermitted: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    permittedSpaces: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    userCapabilities: {
        isLoading: false,
        error: null,
        data: {
            ...$d40b22709becaf61$export$61e797cf03b496e1
        }
    },
    linkedSpaces: {
        isLoading: false,
        data: null,
        error: null,
        totalSize: 0
    },
    showConfluenceCreatePageError: false,
    categoriesData: {
        isLoading: true,
        categories: [],
        isCategoriesSupported: false,
        error: null
    },
    createCategoryData: {
        ...$d40b22709becaf61$export$4947e9942a5d137c
    },
    spaceKey: '',
    flags: []
};
const $d40b22709becaf61$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    initialState: $d40b22709becaf61$export$d4c72bab9d6cc13a,
    actions: $3RIBa.actions,
    name: 'KnowledgeCommonStore'
});
const $d40b22709becaf61$export$d226f0c95b79366b = (0, $dYfll.createSubscriber)($d40b22709becaf61$export$6f57813fe9f31bf9);
const $d40b22709becaf61$export$42b7b5df8c1dee52 = (0, $dYfll.createSubscriber)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    displayName: 'UserCapabilitiesSubscriber',
    selector: (0, $iTtA0.getUserCapabilities)
});
const $d40b22709becaf61$export$a3c47cea95d8bbd1 = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getCommonFlags)
});
const $d40b22709becaf61$export$a9ac4a6dcb7104bf = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getKnowledgeCommonFlags)
});
const $d40b22709becaf61$export$3fa52226f8fff61e = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getCategory)
});
const $d40b22709becaf61$export$2602997fd4d9b312 = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getDraftShareId)
});
const $d40b22709becaf61$export$a5eb46485735066a = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getArticleId)
});
const $d40b22709becaf61$export$428db75bed41f9d = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getIsFetchingDraftDetails)
});
const $d40b22709becaf61$export$e30071c464cba7f9 = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getRedirectionData)
});
const $d40b22709becaf61$export$7ae10e817e068c57 = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getUserCapabilities)
});
const $d40b22709becaf61$export$60270d772f1f3c76 = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getPermittedSpaces)
});
const $d40b22709becaf61$export$40685b8df387d08 = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getLinkedSpaces)
});
const $d40b22709becaf61$export$56b47c5ebac10997 = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getCategoriesData)
});
const $d40b22709becaf61$export$1e7300097c003415 = (0, $ggKAj.createHook)($d40b22709becaf61$export$6f57813fe9f31bf9, {
    selector: (0, $iTtA0.getCreateCategoryData)
});

});
parcelRegister("3RIBa", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f5a49a299435c6a1$export$e324594224ef24da);

var $14AWt = parcelRequire("14AWt");

var $5A1Se = parcelRequire("5A1Se");

var $eLdS8 = parcelRequire("eLdS8");

var $9U3xA = parcelRequire("9U3xA");

var $ee8Cg = parcelRequire("ee8Cg");

var $8WCKw = parcelRequire("8WCKw");

var $7nQEE = parcelRequire("7nQEE");

var $eJinc = parcelRequire("eJinc");

var $fbP9C = parcelRequire("fbP9C");

var $4DLis = parcelRequire("4DLis");

var $jkMm4 = parcelRequire("jkMm4");

var $6JCoa = parcelRequire("6JCoa");

var $4z04Y = parcelRequire("4z04Y");

var $hjVbJ = parcelRequire("hjVbJ");

var $3L3T8 = parcelRequire("3L3T8");

var $5Povy = parcelRequire("5Povy");
const $f5a49a299435c6a1$export$e324594224ef24da = {
    setRedirectionData: $6JCoa.setRedirectionData,
    resetRedirectionData: $6JCoa.resetRedirectionData,
    publishSuccess: $9U3xA.publishSuccess,
    savedSuccess: $ee8Cg.savedSuccess,
    fetchDraftAndNavigateToEditor: $eJinc.fetchDraftAndNavigateToEditor,
    navigateCreateDraftRoute: $jkMm4.navigateCreateDraftRoute,
    fetchCreateArticlePermission: $7nQEE.fetchCreateArticlePermission,
    fetchLinkedSpaces: $fbP9C.fetchLinkedSpaces,
    resetDraftArticleData: $3L3T8.resetDraftArticleData,
    articleDeleteSuccess: $14AWt.articleDeleteSuccess,
    fetchUserCapabilities: $4DLis.fetchUserCapabilities,
    fetchCategories: $8WCKw.fetchCategories,
    reorderCategories: $hjVbJ.reorderCategories,
    createCategory: $5A1Se.createCategory,
    handleFormInputChange: $5A1Se.handleFormInputChange,
    resetCreatedCategory: $5A1Se.resetCreatedCategory,
    updateCategorySuccess: $5Povy.updateCategorySuccess,
    deleteCategorySuccess: $eLdS8.deleteCategorySuccess,
    removeCommonFlag: $4z04Y.removeCommonFlag
};

});
parcelRegister("14AWt", function(module, exports) {

$parcel$export(module.exports, "articleDeleteSuccess", () => $972e80dc2760bfc5$export$7e6f4a244457270c);
const $972e80dc2760bfc5$export$7e6f4a244457270c = (articleId)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            deleted: true,
            articleId: articleId
        });
    };

});

parcelRegister("5A1Se", function(module, exports) {

$parcel$export(module.exports, "createCategory", () => $863a08f3cbd16480$export$7ce9dbcc6d544b1);
$parcel$export(module.exports, "handleFormInputChange", () => $863a08f3cbd16480$export$8e52c4bd9075cb96);
$parcel$export(module.exports, "resetCreatedCategory", () => $863a08f3cbd16480$export$98485bfbe8c8269a);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $b0o4M = parcelRequire("b0o4M");


var $75FYN = parcelRequire("75FYN");

var $kKcMO = parcelRequire("kKcMO");
const $863a08f3cbd16480$export$7ce9dbcc6d544b1 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
        const { formValues: formValues } = {
            ...getState().createCategoryData
        };
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                isSubmitting: true
            }
        });
        try {
            const category = await (0, $75FYN.createCategory)(projectId, formValues, activationId);
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: [
                        ...getState().categoriesData.categories,
                        category
                    ]
                },
                createCategoryData: {
                    ...(0, $kKcMO.initialCreateCategoryData),
                    createdCategory: category
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'categoryCreate success');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const { fieldErrors: fieldErrors, formError: formError } = (0, $b0o4M.toErrors)(error);
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    isSubmitting: false,
                    error: {
                        formError: formError,
                        fieldErrors: fieldErrors
                    }
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'categoryCreate',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $7c4208883f283a36$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };
const $863a08f3cbd16480$export$8e52c4bd9075cb96 = (field, value)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                formValues: {
                    ...getState().createCategoryData.formValues,
                    [field]: value
                }
            }
        });
    };
const $863a08f3cbd16480$export$98485bfbe8c8269a = ()=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            createCategoryData: {
                ...getState().createCategoryData,
                createdCategory: null
            }
        });
    };

});
parcelRegister("b0o4M", function(module, exports) {

$parcel$export(module.exports, "toErrors", () => $e99d0089b24c93c2$export$b0ccdd1765e7cb42);

var $3JafE = parcelRequire("3JafE");
parcelRequire("bI4RP");
parcelRequire("1Lcr1");

var $11yDq = parcelRequire("11yDq");

var $8hktC = parcelRequire("8hktC");
// Ideally JSD Apollo would have i18n in their error messages, however in the absence of that
// we do a conversion here.
const $e99d0089b24c93c2$var$errorKeyToMessage = {
    'jsd.apollo.error.limit.exceeded': (0, $11yDq.default).categoriesLimitExceeded,
    'jsd.apollo.error.project.permission.no.view.project.permission': (0, $11yDq.default).categoriesNoPermission,
    'jsd.apollo.field.error.category.name.cannot.be.blank': (0, $11yDq.default).categoriesNameFieldBlank,
    'jsd.apollo.field.error.category.exceeded.name.length': (0, $11yDq.default).categoriesNameFieldTooLong,
    'jsd.apollo.field.error.category.description.cannot.be.blank': (0, $11yDq.default).categoriesDescriptionFieldBlank,
    'jsd.apollo.field.error.category.exceeded.description.length': (0, $11yDq.default).categoriesDescriptionFieldTooLong
};
const $e99d0089b24c93c2$export$b0ccdd1765e7cb42 = (errorResponse)=>{
    const fieldErrorsResponse = errorResponse.fieldErrors || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldErrors = Object.keys(fieldErrorsResponse).reduce((acc, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acc,
            [field]: {
                message: // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'jsd.apollo.error.limit.exceeded': MessageDescriptorV2; readonly 'jsd.apollo.error.project.permission.no.view.project.permission': MessageDescriptorV2; readonly 'jsd.apollo.field.error.category.name.cannot.be.blank': MessageDescriptorV2;
                $e99d0089b24c93c2$var$errorKeyToMessage[fieldErrorsResponse[field].errorKey] || (0, $11yDq.default).categoriesGenericMessage
            }
        }), {});
    const formError = errorResponse.errorKey ? {
        message: // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'jsd.apollo.error.limit.exceeded': MessageDescriptorV2; readonly 'jsd.apollo.error.project.permission.no.view.project.permission': MessageDescriptorV2; readonly 'jsd.apollo.field.error.category.name.cannot.be.blank': MessageDescriptorV2;
        $e99d0089b24c93c2$var$errorKeyToMessage[errorResponse.errorKey] || (0, $11yDq.default).categoriesGenericMessage
    } : undefined;
    return {
        formError: formError,
        fieldErrors: fieldErrors
    };
};
const $e99d0089b24c93c2$export$7ce9dbcc6d544b1 = (projectId, activationId, payload)=>(0, $8hktC.createCategory)(projectId, activationId, payload).catch((errorResponse)=>(0, $3JafE.Observable).throw({
            nativeError: errorResponse,
            formattedError: $e99d0089b24c93c2$export$b0ccdd1765e7cb42(errorResponse)
        }));
const $e99d0089b24c93c2$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload)=>(0, $8hktC.updateCategory)(projectId, categoryId, activationId, payload).catch((errorResponse)=>(0, $3JafE.Observable).throw($e99d0089b24c93c2$export$b0ccdd1765e7cb42(errorResponse)));

});
parcelRegister("11yDq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b890fa5d64a33696$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b890fa5d64a33696$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    categoriesGenericMessage: {
        "id": "servicedesk-knowledge-services.categories-generic-message",
        "defaultMessage": "We couldn't create the category. Wait a moment, then try again."
    },
    categoriesNoPermission: {
        "id": "servicedesk-knowledge-services.categories-no-permission",
        "defaultMessage": "You'll need to be an agent to create a category. Ask an admin to check your permissions."
    },
    categoriesLimitExceeded: {
        "id": "servicedesk-knowledge-services.categories-limit-exceeded",
        "defaultMessage": "You have exceeded the maximum number of categories for this project. The maximum number of categories per project is 30."
    },
    categoriesNameFieldBlank: {
        "id": "servicedesk-knowledge-services.categories-name-field-blank",
        "defaultMessage": "Name cannot be blank"
    },
    categoriesDescriptionFieldBlank: {
        "id": "servicedesk-knowledge-services.categories-description-field-blank",
        "defaultMessage": "Description cannot be blank"
    },
    categoriesNameFieldTooLong: {
        "id": "servicedesk-knowledge-services.categories-name-field-too-long",
        "defaultMessage": "Name cannot be longer than 100 characters"
    },
    categoriesDescriptionFieldTooLong: {
        "id": "servicedesk-knowledge-services.categories-description-field-too-long",
        "defaultMessage": "Description cannot be longer than 150 characters"
    }
});

});

parcelRegister("8hktC", function(module, exports) {

$parcel$export(module.exports, "listCategories", () => $0d975be4df003b3a$export$db54be5b1772ef4b);
$parcel$export(module.exports, "createCategory", () => $0d975be4df003b3a$export$7ce9dbcc6d544b1);
$parcel$export(module.exports, "updateCategory", () => $0d975be4df003b3a$export$daaacb0271870c9);

var $3JafE = parcelRequire("3JafE");
parcelRequire("bI4RP");
parcelRequire("1Lcr1");

var $5SOXK = parcelRequire("5SOXK");

var $2oGfJ = parcelRequire("2oGfJ");

const $0d975be4df003b3a$export$db54be5b1772ef4b = (projectId, activationId, apolloPath = (0, $64356a5e39dcf909$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category`;
    return (0, $5SOXK.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`);
};
const $0d975be4df003b3a$export$c0a90379dccf4f2f = (projectId, categoryId, activationId, apolloPath = (0, $64356a5e39dcf909$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category/`;
    return (0, $5SOXK.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}${(0, $2oGfJ.categoryGuidToString)(categoryId)}`, {
        method: 'DELETE'
    });
};
const $0d975be4df003b3a$export$7ce9dbcc6d544b1 = (projectId, activationId, payload, apolloPath = (0, $64356a5e39dcf909$export$f224912d4ec4705e))=>{
    const categoryPath = `api/project/${projectId}/category`;
    return (0, $5SOXK.fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`, {
        method: 'POST',
        body: JSON.stringify(payload)
    }).catch(({ response: response })=>(0, $3JafE.Observable).throw(response));
};
const $0d975be4df003b3a$export$ce3ba7bb235ce057 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $64356a5e39dcf909$export$f224912d4ec4705e) })=>{
    let body = {
        articleId: articleId,
        featured: isFeatured
    };
    // @ts-expect-error - TS2322 - Type '{ spaceKey: string; articleId: string; featured: boolean | undefined; }' is not assignable to type '{ articleId: string; featured: boolean | undefined; }'.
    body = {
        ...body,
        spaceKey: spaceKey
    };
    return (0, $5SOXK.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2oGfJ.categoryGuidToString)(categoryId)}/article`, {
        method: 'POST',
        body: JSON.stringify(body)
    });
};
const $0d975be4df003b3a$export$b6002acecf935894 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $64356a5e39dcf909$export$f224912d4ec4705e) })=>(0, $5SOXK.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2oGfJ.categoryGuidToString)(categoryId)}/spaceKey/${spaceKey}/article/${articleId}`, {
        method: 'DELETE'
    });
const $0d975be4df003b3a$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload, apolloPath = (0, $64356a5e39dcf909$export$f224912d4ec4705e))=>(0, $5SOXK.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2oGfJ.categoryGuidToString)(categoryId)}`, {
        method: 'PUT',
        body: JSON.stringify(payload)
    }).catch(({ response: response })=>(0, $3JafE.Observable).throw(response));
const $0d975be4df003b3a$export$b9f575b5360cf530 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $64356a5e39dcf909$export$f224912d4ec4705e) })=>{
    let body = {
        featured: isFeatured
    };
    // @ts-expect-error - TS2322 - Type '{ spaceKey: string; featured: boolean; }' is not assignable to type '{ featured: boolean; }'.
    body = {
        ...body,
        spaceKey: spaceKey
    };
    return (0, $5SOXK.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, $2oGfJ.categoryGuidToString)(categoryId)}/article/${articleId}`, {
        method: 'PUT',
        body: JSON.stringify(body)
    }).catch(({ response: response })=>(0, $3JafE.Observable).throw(response));
};
const $0d975be4df003b3a$export$e90b3dc42a0ddf96 = ({ projectId: projectId, categories: categories, activationId: activationId, apolloPath: apolloPath = (0, $64356a5e39dcf909$export$f224912d4ec4705e) })=>(0, $5SOXK.fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/order`, {
        method: 'PUT',
        body: JSON.stringify(categories)
    }).catch(({ response: response })=>(0, $3JafE.Observable).throw(response));

});
parcelRegister("5SOXK", function(module, exports) {

$parcel$export(module.exports, "fetchJson$", () => $14949259afbc8828$export$2ba52855e389d39e);
$parcel$export(module.exports, "fetchText$", () => $14949259afbc8828$export$64ab95a52860b608);
parcelRequire("bI4RP");
parcelRequire("1Lcr1");

var $6G5mG = parcelRequire("6G5mG");

var $3JafE = parcelRequire("3JafE");

var $2OdyW = parcelRequire("2OdyW");
var $aiRd8 = parcelRequire("aiRd8");
var $5G2eQ = parcelRequire("5G2eQ");

var $fV97Z = parcelRequire("fV97Z");
const $14949259afbc8828$var$buildErrorResponse = (message, statusCode)=>({
        response: {
            errors: [
                {
                    errorMessage: message
                }
            ],
            reasonKey: 'generic.error',
            reasonCode: `${statusCode}`
        },
        statusCode: statusCode
    });
const $14949259afbc8828$var$toAnError = (error)=>{
    try {
        // ServiceDesk REST errors be usually be in the form of a JSON
        // object (e.g., AnError).  We'll try to parse it.
        const response = JSON.parse(error.message);
        // Normalize the shape of "simple" JSON error responses containing
        // message and status-code, as used in e.g., standard Jira
        // unauthorized response.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(response, 'message') && (0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(response, 'status-code')) return $14949259afbc8828$var$buildErrorResponse(response.message, parseInt(response['status-code'], 10));
        return {
            response: response,
            statusCode: error.statusCode
        };
    } catch (e) {
        // Message didn't parse as JSON; assume it's a plain ol' string, and
        // we'll produce an AnError-like object with it.
        return $14949259afbc8828$var$buildErrorResponse(error.message, error.statusCode);
    }
};
const $14949259afbc8828$export$6d71b655afe1638d = (url, opts)=>(0, $2OdyW.default)(url, opts).catch((error)=>Promise.reject($14949259afbc8828$var$toAnError(error)));
const $14949259afbc8828$export$2ba52855e389d39e = (url, opts)=>(0, $aiRd8.default)(url, opts).catch((error)=>(0, $3JafE.Observable).throw($14949259afbc8828$var$toAnError(error)));
const $14949259afbc8828$export$64ab95a52860b608 = (url, opts)=>(0, $5G2eQ.default)(url, opts).catch((error)=>(0, $3JafE.Observable).throw($14949259afbc8828$var$toAnError(error)));

});
parcelRegister("aiRd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6464cf3e92eca984$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("8OtG5");
parcelRequire("flmol");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $6iz4v = parcelRequire("6iz4v");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $etaBp = parcelRequire("etaBp");
const $6464cf3e92eca984$var$noContentStatus = 204;
const $6464cf3e92eca984$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $6464cf3e92eca984$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$6464cf3e92eca984$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $6iz4v.setMark)(`BEGIN_${key}`);
    }
    return (0, $3JafE.Observable).of(url).mergeMap(()=>fetch(url, (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), opts), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $6iz4v.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, str, traceId);
                else throw new (0, $7byHA.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $6464cf3e92eca984$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        return response.json();
    });
}
var $6464cf3e92eca984$export$2e2bcd8739ae039 = $6464cf3e92eca984$var$fetchJson$;

});

parcelRegister("5G2eQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9fb25724578ccf$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $etaBp = parcelRequire("etaBp");
const $0d9fb25724578ccf$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$0d9fb25724578ccf$export$2e2bcd8739ae039 = (url, options = {})=>(0, $3JafE.Observable).of(url).mergeMap(()=>fetch(url, (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), options), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $7byHA.default)(status);
        }
        if (response.status === $0d9fb25724578ccf$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $3JafE.Observable).of(response.responseText || 'OK');
    });

});


parcelRegister("2oGfJ", function(module, exports) {

$parcel$export(module.exports, "categoryGuidToString", () => $4eab8fcda8a92dbd$export$43162cfd3260b2fe);
$parcel$export(module.exports, "toCategoryGuid", () => $4eab8fcda8a92dbd$export$be5c80c4ad1faf99);
const $4eab8fcda8a92dbd$export$804bcd2704a6d077 = (appLinkId)=>appLinkId;
const $4eab8fcda8a92dbd$export$43162cfd3260b2fe = (guid)=>guid;
const $4eab8fcda8a92dbd$export$be5c80c4ad1faf99 = (guid)=>guid;

});

const $64356a5e39dcf909$export$8ce6d23ffa1a190a = '/jsd-apollo';
const $64356a5e39dcf909$export$f224912d4ec4705e = '/gateway/api/jsd-apollo-stargate/sharded/workspace';



const $7c4208883f283a36$export$d42203c46ecda0b5 = 'ncs';
const $7c4208883f283a36$export$22ba648868203514 = 'synchrony';
const $7c4208883f283a36$export$f6fc4a5779d5dc2c = 'JSM';
const $7c4208883f283a36$export$a40257481ddef37e = 'atlassianAccount';
const $7c4208883f283a36$export$d57b6b390e78d90f = 'jsm-nebula';
const $7c4208883f283a36$export$85314a8fbb8155e1 = 'MONTHLY';
const $7c4208883f283a36$export$d1eb58f682ad65ad = 'ANNUAL';
const $7c4208883f283a36$export$1635bbf8efc1cbc4 = 'INACTIVE';

parcelRegister("75FYN", function(module, exports) {

$parcel$export(module.exports, "createCategory", () => $0f6943c11c818ead$export$7ce9dbcc6d544b1);

var $2OdyW = parcelRequire("2OdyW");

const $0f6943c11c818ead$export$f0b37505cff627e3 = (projectId, activationId)=>`${0, $64356a5e39dcf909$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
const $0f6943c11c818ead$export$7ce9dbcc6d544b1 = (projectId, payload, activationId)=>{
    const url = $0f6943c11c818ead$export$f0b37505cff627e3(projectId, activationId);
    return (0, $2OdyW.default)(url, {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

});


parcelRegister("eLdS8", function(module, exports) {

$parcel$export(module.exports, "deleteCategorySuccess", () => $02e9ca6f69a45389$export$aa2eaa46022bd60b);
const $02e9ca6f69a45389$export$aa2eaa46022bd60b = (categoryId)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: [
                    ...getState().categoriesData.categories.filter((category)=>category.id !== categoryId)
                ]
            }
        });
    };

});

parcelRegister("9U3xA", function(module, exports) {

$parcel$export(module.exports, "publishSuccess", () => $50ae1e27ff61b417$export$a435a3808fe5155f);
const $50ae1e27ff61b417$export$a435a3808fe5155f = ({ articleId: articleId, draftShareId: draftShareId, spaceKey: spaceKey })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            published: true,
            articleId: articleId,
            draftShareId: draftShareId,
            spaceKey: spaceKey
        });
    };

});

parcelRegister("ee8Cg", function(module, exports) {

$parcel$export(module.exports, "savedSuccess", () => $27de547f3034af88$export$2bf589c797fe6b4f);
const $27de547f3034af88$export$2bf589c797fe6b4f = ({ articleId: articleId, draftShareId: draftShareId })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            closed: true,
            articleId: articleId,
            draftShareId: draftShareId
        });
    };

});

parcelRegister("8WCKw", function(module, exports) {

$parcel$export(module.exports, "fetchCategories", () => $f7f2bebcbb096b52$export$416ec9f5729de215);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");


var $iYYe2 = parcelRequire("iYYe2");
const $f7f2bebcbb096b52$export$416ec9f5729de215 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...getState(),
            categoriesData: {
                ...initialState.categoriesData,
                isLoading: true
            }
        });
        try {
            const { categories: categories, categoriesSupported: categoriesSupported } = await (0, $iYYe2.fetchCategories)(projectId, activationId);
            setState({
                ...getState(),
                categoriesData: {
                    categories: categories,
                    isCategoriesSupported: categoriesSupported,
                    isLoading: false,
                    error: null
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'onFetchCategories success', {
                projectId: projectId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                categoriesData: {
                    ...initialState.categoriesData,
                    isLoading: false,
                    error: error
                }
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'onFetchCategoriesFailure',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $7c4208883f283a36$export$d57b6b390e78d90f)
                },
                error: error
            });
        }
    };

});
parcelRegister("iYYe2", function(module, exports) {

$parcel$export(module.exports, "fetchCategories", () => $4361849ecbf5c505$export$416ec9f5729de215);

var $2OdyW = parcelRequire("2OdyW");

const $4361849ecbf5c505$export$5cf4b2ebebe43941 = (projectId, activationId)=>`${0, $64356a5e39dcf909$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
const $4361849ecbf5c505$export$416ec9f5729de215 = (projectId, activationId)=>{
    const url = $4361849ecbf5c505$export$5cf4b2ebebe43941(projectId, activationId);
    return (0, $2OdyW.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("7nQEE", function(module, exports) {

$parcel$export(module.exports, "fetchCreateArticlePermission", () => $5f6178f64dbe6934$export$c5bf032e1fb1ad18);

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");

var $gYTBU = parcelRequire("gYTBU");

var $2oPLp = parcelRequire("2oPLp");
const $5f6178f64dbe6934$var$EVENT_NAME = 'createPermissionsForSpace';
const $5f6178f64dbe6934$export$c5bf032e1fb1ad18 = ({ cloudId: cloudId, spaceKeys: spaceKeys, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...initialState,
            spacesPermitted: {
                ...initialState.spacesPermitted,
                isLoading: true
            }
        });
        try {
            const { promotedSpaces: promotedSpaces } = await ((0, $1ybV0.ff)('jira-service-desk-confluence-stargate') ? (0, $2oPLp.getCreatePermissionsForSpace)(cloudId, spaceKeys) : (0, $2oPLp.getCreatePermissionsForSpaceOld)(spaceKeys));
            const permittedSpaces = promotedSpaces.spaces.map(// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'text' implicitly has an 'any' type.
            ({ id: id, text: text })=>({
                    spaceKey: id,
                    spaceName: text
                }));
            setState({
                ...initialState,
                spacesPermitted: {
                    ...initialState.spacesPermitted,
                    isLoading: false,
                    data: permittedSpaces,
                    totalSize: promotedSpaces.spaces.length
                }
            });
            // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${$5f6178f64dbe6934$var$EVENT_NAME} succedded`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...initialState,
                spacesPermitted: {
                    ...initialState.spacesPermitted,
                    isLoading: false,
                    error: error
                }
            });
            (0, $gYTBU.fireErrorAnalyticsEvents)(error, 'createSpacePermissions', 'knowledgeCommon');
        }
    };

});
parcelRegister("gYTBU", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalyticsEvents", () => $35cfd88bf082cdaf$export$b84e314c48e09c44);
$parcel$export(module.exports, "getPageOnDelete", () => $35cfd88bf082cdaf$export$99689dbe56145ad5);
$parcel$export(module.exports, "fireCustomErrorAnalytics", () => $35cfd88bf082cdaf$export$3d13cbe76aeaf5e8);
$parcel$export(module.exports, "getViewArticleUrl", () => $35cfd88bf082cdaf$export$4b1de73aa951498c);
$parcel$export(module.exports, "getAllDraftsUrl", () => $35cfd88bf082cdaf$export$939c0821a1193768);
$parcel$export(module.exports, "getAllArticlesUrl", () => $35cfd88bf082cdaf$export$240e98bbb8304c52);
$parcel$export(module.exports, "getFlag", () => $35cfd88bf082cdaf$export$a19b74191e00c5e);
$parcel$export(module.exports, "getCommonFlagData", () => $35cfd88bf082cdaf$export$f44d45dc3db56277);
$parcel$export(module.exports, "filterSupportedBillingPeriod", () => $35cfd88bf082cdaf$export$9f13ed259dc4b1bf);
$parcel$export(module.exports, "formatTrialEndDate", () => $35cfd88bf082cdaf$export$da56c66ce2766e02);

var $kHLYt = parcelRequire("kHLYt");

var $guiFP = parcelRequire("guiFP");

var $7EhAs = parcelRequire("7EhAs");

var $jMP2a = parcelRequire("jMP2a");


const $35cfd88bf082cdaf$var$TEAM_NAME = 'jsm-nebula';
const $35cfd88bf082cdaf$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $35cfd88bf082cdaf$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $35cfd88bf082cdaf$export$53ee51427129200c = (statusCode)=>$35cfd88bf082cdaf$export$1a5a4674dd906e7e(statusCode) || $35cfd88bf082cdaf$export$d31fd506ce75fa65(statusCode);
const $35cfd88bf082cdaf$export$b84e314c48e09c44 = (error, id, packageName, attributes)=>{
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    if (error && typeof error.statusCode === 'number') {
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
        const { statusCode: statusCode } = error;
        const lowPriorityError = statusCode >= 400 && statusCode < 500;
        const errorMetaId = lowPriorityError ? `${id}__4xx` : `${id}`;
        const transformedError = error instanceof (0, $7EhAs.default) ? error : new (0, $7EhAs.default)(statusCode);
        const errorObj = {
            error: transformedError,
            meta: {
                id: errorMetaId,
                packageName: packageName,
                teamName: $35cfd88bf082cdaf$var$TEAM_NAME
            },
            ...attributes && {
                attributes: attributes
            }
        };
        (0, $guiFP.default)(errorObj);
    } else (0, $guiFP.default)({
        // Note there should not be a case of circular object for error , if there is it will be handled by fireErrorAnalytics
        error: error instanceof Error ? error : new Error(JSON.stringify(error)),
        meta: {
            id: `${id}__JS_ERROR`,
            packageName: packageName,
            teamName: $35cfd88bf082cdaf$var$TEAM_NAME
        },
        ...attributes && {
            attributes: attributes
        }
    });
};
const $35cfd88bf082cdaf$export$99689dbe56145ad5 = (currentPage, updateDataSize, perPage)=>{
    const lastPage = Math.ceil(updateDataSize / perPage);
    return currentPage > lastPage ? lastPage : currentPage;
};
const $35cfd88bf082cdaf$export$3d13cbe76aeaf5e8 = ({ error: error, event: event, id: id, packageName: packageName, attributes: attributes })=>{
    if (error && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    typeof error.statusCode === 'number' && // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | FetchError | ErrorResponse'.
    !$35cfd88bf082cdaf$export$53ee51427129200c(error.statusCode)) event && (0, $jMP2a.fireOperationalAnalytics)(event, id);
    $35cfd88bf082cdaf$export$b84e314c48e09c44(error, id, packageName, attributes);
};
const $35cfd88bf082cdaf$export$4b1de73aa951498c = (projectKey, contentId, spaceKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles/${contentId}?spaceKey=${spaceKey}`;
const $35cfd88bf082cdaf$export$939c0821a1193768 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/drafts`;
const $35cfd88bf082cdaf$export$240e98bbb8304c52 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles`;
const $35cfd88bf082cdaf$export$a19b74191e00c5e = (title, description, flagType)=>({
        title: title,
        description: description,
        id: (0, $kHLYt.generate)(),
        flagType: flagType
    });
const $35cfd88bf082cdaf$export$a6125e21263de883 = (state)=>{
    const { draftShareId: draftShareId, articleId: articleId, published: published, closed: closed, deleted: deleted } = state;
    const isDraftPublished = Boolean(draftShareId && articleId && published && !closed);
    const isArticleSavedWithUnpublishedChanges = Boolean(!draftShareId && articleId && !published && closed);
    const isDraftSavedWithUnpublishedChanges = Boolean(draftShareId && articleId && closed && !published);
    const isArticleDeleted = Boolean(articleId && deleted);
    return {
        isDraftPublished: isDraftPublished,
        isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges,
        isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges,
        isArticleDeleted: isArticleDeleted
    };
};
const $35cfd88bf082cdaf$export$f44d45dc3db56277 = (state, messages)=>{
    let flag = {
        id: '',
        title: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        description: {
            id: '',
            defaultMessage: '',
            description: ''
        },
        type: (0, $eff1a8232a4d6c64$export$f215947b3d76a6b7)
    };
    const { showConfluenceCreatePageError: showConfluenceCreatePageError } = state;
    // if confluence get content api fails
    if (showConfluenceCreatePageError) {
        flag = {
            id: 'draftErrorFlag',
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            title: messages.confluenceCreatePageFailureTitle,
            // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
            description: messages.confluenceCreatePageFailureDescription,
            type: (0, $eff1a8232a4d6c64$export$f215947b3d76a6b7)
        };
        return flag;
    }
    const { isDraftPublished: isDraftPublished, isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges, isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges, isArticleDeleted: isArticleDeleted } = $35cfd88bf082cdaf$export$a6125e21263de883(state);
    // case when new article is published --> Article View
    if (isDraftPublished) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $eff1a8232a4d6c64$export$516433e8a6db7503)
    };
    // case when draft is saved with unpublished changes --> Browse All Articles Page
    if (isDraftSavedWithUnpublishedChanges) flag = {
        id: 'draftSavedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.draftSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'string | MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.draftSuccessSavedFlagDescription || '',
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $eff1a8232a4d6c64$export$516433e8a6db7503)
    };
    // case when older article is saved with unpublished changes --> Article View
    if (isArticleSavedWithUnpublishedChanges) flag = {
        id: 'draftPublishedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleSuccessSavedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleSuccessSavedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $eff1a8232a4d6c64$export$516433e8a6db7503)
    };
    // case when article is deleted --> Browse All Articles Page
    if (isArticleDeleted) flag = {
        id: 'articleDeletedFlag',
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        title: messages.articleDeletedFlagTitle,
        // @ts-expect-error - TS2322 - Type 'MessageDescriptorV2' is not assignable to type '{ id: string; defaultMessage: string; description: string; }'.
        description: messages.articleDeletedFlagDescription,
        // @ts-expect-error - TS2322 - Type '"SUCCESS"' is not assignable to type '"ERROR"'.
        type: (0, $eff1a8232a4d6c64$export$516433e8a6db7503)
    };
    return flag;
};
const $35cfd88bf082cdaf$export$9f13ed259dc4b1bf = (billingPeriod)=>{
    if (billingPeriod === (0, $7c4208883f283a36$export$85314a8fbb8155e1)) return 0, $7c4208883f283a36$export$85314a8fbb8155e1;
    if (billingPeriod === (0, $7c4208883f283a36$export$d1eb58f682ad65ad)) return 0, $7c4208883f283a36$export$d1eb58f682ad65ad;
    return 0, $7c4208883f283a36$export$1635bbf8efc1cbc4;
};
const $35cfd88bf082cdaf$export$da56c66ce2766e02 = (trialEndDate)=>{
    if (trialEndDate != null && trialEndDate !== '') return new Date(trialEndDate);
    return null;
};

});
parcelRegister("kHLYt", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hpfs8"));

});
parcelRegister("hpfs8", function(module, exports) {
'use strict';

var $65vow = parcelRequire("65vow");

var $2OSrw = parcelRequire("2OSrw");

var $2d1Ll = parcelRequire("2d1Ll");

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var $cac0c20fc2eeacc1$var$clusterWorkerId = (parcelRequire("ayyu4")) || 0;
/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */ function $cac0c20fc2eeacc1$var$seed(seedValue) {
    $65vow.seed(seedValue);
    return module.exports;
}
/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */ function $cac0c20fc2eeacc1$var$worker(workerId) {
    $cac0c20fc2eeacc1$var$clusterWorkerId = workerId;
    return module.exports;
}
/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */ function $cac0c20fc2eeacc1$var$characters(newCharacters) {
    if (newCharacters !== undefined) $65vow.characters(newCharacters);
    return $65vow.shuffled();
}
/**
 * Generate unique id
 * Returns string id
 */ function $cac0c20fc2eeacc1$var$generate() {
    return $2OSrw($cac0c20fc2eeacc1$var$clusterWorkerId);
}
// Export all other functions as properties of the generate function
module.exports = $cac0c20fc2eeacc1$var$generate;
module.exports.generate = $cac0c20fc2eeacc1$var$generate;
module.exports.seed = $cac0c20fc2eeacc1$var$seed;
module.exports.worker = $cac0c20fc2eeacc1$var$worker;
module.exports.characters = $cac0c20fc2eeacc1$var$characters;
module.exports.isValid = $2d1Ll;

});
parcelRegister("65vow", function(module, exports) {
'use strict';

var $7x6JO = parcelRequire("7x6JO");
var $46eb8ffb0f48314e$var$ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var $46eb8ffb0f48314e$var$alphabet;
var $46eb8ffb0f48314e$var$previousSeed;
var $46eb8ffb0f48314e$var$shuffled;
function $46eb8ffb0f48314e$var$reset() {
    $46eb8ffb0f48314e$var$shuffled = false;
}
function $46eb8ffb0f48314e$var$setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if ($46eb8ffb0f48314e$var$alphabet !== $46eb8ffb0f48314e$var$ORIGINAL) {
            $46eb8ffb0f48314e$var$alphabet = $46eb8ffb0f48314e$var$ORIGINAL;
            $46eb8ffb0f48314e$var$reset();
        }
        return;
    }
    if (_alphabet_ === $46eb8ffb0f48314e$var$alphabet) return;
    if (_alphabet_.length !== $46eb8ffb0f48314e$var$ORIGINAL.length) throw new Error('Custom alphabet for shortid must be ' + $46eb8ffb0f48314e$var$ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    var unique = _alphabet_.split('').filter(function(item, ind, arr) {
        return ind !== arr.lastIndexOf(item);
    });
    if (unique.length) throw new Error('Custom alphabet for shortid must be ' + $46eb8ffb0f48314e$var$ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    $46eb8ffb0f48314e$var$alphabet = _alphabet_;
    $46eb8ffb0f48314e$var$reset();
}
function $46eb8ffb0f48314e$var$characters(_alphabet_) {
    $46eb8ffb0f48314e$var$setCharacters(_alphabet_);
    return $46eb8ffb0f48314e$var$alphabet;
}
function $46eb8ffb0f48314e$var$setSeed(seed) {
    $7x6JO.seed(seed);
    if ($46eb8ffb0f48314e$var$previousSeed !== seed) {
        $46eb8ffb0f48314e$var$reset();
        $46eb8ffb0f48314e$var$previousSeed = seed;
    }
}
function $46eb8ffb0f48314e$var$shuffle() {
    if (!$46eb8ffb0f48314e$var$alphabet) $46eb8ffb0f48314e$var$setCharacters($46eb8ffb0f48314e$var$ORIGINAL);
    var sourceArray = $46eb8ffb0f48314e$var$alphabet.split('');
    var targetArray = [];
    var r = $7x6JO.nextValue();
    var characterIndex;
    while(sourceArray.length > 0){
        r = $7x6JO.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}
function $46eb8ffb0f48314e$var$getShuffled() {
    if ($46eb8ffb0f48314e$var$shuffled) return $46eb8ffb0f48314e$var$shuffled;
    $46eb8ffb0f48314e$var$shuffled = $46eb8ffb0f48314e$var$shuffle();
    return $46eb8ffb0f48314e$var$shuffled;
}
/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */ function $46eb8ffb0f48314e$var$lookup(index) {
    var alphabetShuffled = $46eb8ffb0f48314e$var$getShuffled();
    return alphabetShuffled[index];
}
function $46eb8ffb0f48314e$var$get() {
    return $46eb8ffb0f48314e$var$alphabet || $46eb8ffb0f48314e$var$ORIGINAL;
}
module.exports = {
    get: $46eb8ffb0f48314e$var$get,
    characters: $46eb8ffb0f48314e$var$characters,
    seed: $46eb8ffb0f48314e$var$setSeed,
    lookup: $46eb8ffb0f48314e$var$lookup,
    shuffled: $46eb8ffb0f48314e$var$getShuffled
};

});
parcelRegister("7x6JO", function(module, exports) {
'use strict';
// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
var $57c0d77552ad4453$var$seed = 1;
/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */ function $57c0d77552ad4453$var$getNextValue() {
    $57c0d77552ad4453$var$seed = ($57c0d77552ad4453$var$seed * 9301 + 49297) % 233280;
    return $57c0d77552ad4453$var$seed / 233280.0;
}
function $57c0d77552ad4453$var$setSeed(_seed_) {
    $57c0d77552ad4453$var$seed = _seed_;
}
module.exports = {
    nextValue: $57c0d77552ad4453$var$getNextValue,
    seed: $57c0d77552ad4453$var$setSeed
};

});


parcelRegister("2OSrw", function(module, exports) {
'use strict';

var $lu4fN = parcelRequire("lu4fN");
parcelRequire("65vow");
// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var $20da7b7c8d36468d$var$REDUCE_TIME = 1567752802062;
// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var $20da7b7c8d36468d$var$version = 7;
// Counter is used when shortid is called multiple times in one second.
var $20da7b7c8d36468d$var$counter;
// Remember the last time shortid was called in case counter is needed.
var $20da7b7c8d36468d$var$previousSeconds;
/**
 * Generate unique id
 * Returns string id
 */ function $20da7b7c8d36468d$var$build(clusterWorkerId) {
    var str = '';
    var seconds = Math.floor((Date.now() - $20da7b7c8d36468d$var$REDUCE_TIME) * 0.001);
    if (seconds === $20da7b7c8d36468d$var$previousSeconds) $20da7b7c8d36468d$var$counter++;
    else {
        $20da7b7c8d36468d$var$counter = 0;
        $20da7b7c8d36468d$var$previousSeconds = seconds;
    }
    str = str + $lu4fN($20da7b7c8d36468d$var$version);
    str = str + $lu4fN(clusterWorkerId);
    if ($20da7b7c8d36468d$var$counter > 0) str = str + $lu4fN($20da7b7c8d36468d$var$counter);
    str = str + $lu4fN(seconds);
    return str;
}
module.exports = $20da7b7c8d36468d$var$build;

});
parcelRegister("lu4fN", function(module, exports) {
'use strict';

var $65vow = parcelRequire("65vow");

var $7daI6 = parcelRequire("7daI6");

var $kBuh4 = parcelRequire("kBuh4");
function $fa3fb30a71d62940$var$generate(number) {
    var loopCounter = 0;
    var done;
    var str = '';
    while(!done){
        str = str + $kBuh4($7daI6, $65vow.get(), 1);
        done = number < Math.pow(16, loopCounter + 1);
        loopCounter++;
    }
    return str;
}
module.exports = $fa3fb30a71d62940$var$generate;

});
parcelRegister("7daI6", function(module, exports) {
'use strict';
var $54020e23c6d7c9e9$var$crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
var $54020e23c6d7c9e9$var$randomByte;
if (!$54020e23c6d7c9e9$var$crypto || !$54020e23c6d7c9e9$var$crypto.getRandomValues) $54020e23c6d7c9e9$var$randomByte = function(size) {
    var bytes = [];
    for(var i = 0; i < size; i++)bytes.push(Math.floor(Math.random() * 256));
    return bytes;
};
else $54020e23c6d7c9e9$var$randomByte = function(size) {
    return $54020e23c6d7c9e9$var$crypto.getRandomValues(new Uint8Array(size));
};
module.exports = $54020e23c6d7c9e9$var$randomByte;

});

parcelRegister("kBuh4", function(module, exports) {
// This file replaces `format.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.
module.exports = function(random, alphabet, size) {
    // We can’t use bytes bigger than the alphabet. To make bytes values closer
    // to the alphabet, we apply bitmask on them. We look for the closest
    // `2 ** x - 1` number, which will be bigger than alphabet size. If we have
    // 30 symbols in the alphabet, we will take 31 (00011111).
    // We do not use faster Math.clz32, because it is not available in browsers.
    var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    // Bitmask is not a perfect solution (in our example it will pass 31 bytes,
    // which is bigger than the alphabet). As a result, we will need more bytes,
    // than ID size, because we will refuse bytes bigger than the alphabet.
    // Every hardware random generator call is costly,
    // because we need to wait for entropy collection. This is why often it will
    // be faster to ask for few extra bytes in advance, to avoid additional calls.
    // Here we calculate how many random bytes should we call in advance.
    // It depends on ID length, mask / alphabet size and magic number 1.6
    // (which was selected according benchmarks).
    // -~f => Math.ceil(f) if n is float number
    // -~i => i + 1 if n is integer number
    var step = -~(1.6 * mask * size / alphabet.length);
    var id = '';
    while(true){
        var bytes = random(step);
        // Compact alternative for `for (var i = 0; i < step; i++)`
        var i = step;
        while(i--){
            // If random byte is bigger than alphabet even after bitmask,
            // we refuse it by `|| ''`.
            id += alphabet[bytes[i] & mask] || '';
            // More compact than `id.length + 1 === size`
            if (id.length === +size) return id;
        }
    }
};

});



parcelRegister("2d1Ll", function(module, exports) {
'use strict';

var $65vow = parcelRequire("65vow");
function $19be29b228f8ca37$var$isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6) return false;
    var nonAlphabetic = new RegExp('[^' + $65vow.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') + ']');
    return !nonAlphabetic.test(id);
}
module.exports = $19be29b228f8ca37$var$isShortId;

});

parcelRegister("ayyu4", function(module, exports) {
'use strict';
module.exports = 0;

});



const $eff1a8232a4d6c64$export$516433e8a6db7503 = 'SUCCESS';
const $eff1a8232a4d6c64$export$a0a5e05447abb018 = 'WARNING';
const $eff1a8232a4d6c64$export$f215947b3d76a6b7 = 'ERROR';
const $eff1a8232a4d6c64$export$21bdd502a5302e06 = 'INFO';


parcelRegister("2oPLp", function(module, exports) {

$parcel$export(module.exports, "getCreatePermissionsForSpaceOld", () => $3d2f1b777a01902a$export$330428b01395d171);
$parcel$export(module.exports, "getCreatePermissionsForSpace", () => $3d2f1b777a01902a$export$a4d40fb662e5fd46);
$parcel$export(module.exports, "getLinkedSpaces", () => $3d2f1b777a01902a$export$b764c9ef97480a8e);

var $53ciZ = parcelRequire("53ciZ");

var $2OdyW = parcelRequire("2OdyW");

var $5UrQm = parcelRequire("5UrQm");



const $3d2f1b777a01902a$export$330428b01395d171 = (spaceKeys)=>{
    const queryString = (0, $53ciZ.stringify)({
        promotedSpaceKey: spaceKeys,
        promotedSpacesLimit: spaceKeys.length,
        otherSpacesLimit: 0
    });
    return (0, $2OdyW.default)(`/wiki/rest/create-dialog/1.0/spaces?${queryString}`);
};
const $3d2f1b777a01902a$export$a4d40fb662e5fd46 = (cloudId, spaceKeys)=>{
    const queryString = (0, $53ciZ.stringify)({
        promotedSpaceKey: spaceKeys,
        promotedSpacesLimit: spaceKeys.length,
        otherSpacesLimit: 0
    });
    return (0, $2OdyW.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/spaces?${queryString}`);
};
const $3d2f1b777a01902a$export$b764c9ef97480a8e = (projectKey)=>(0, $2OdyW.default)(`/rest/servicedesk/1/servicedesk/${projectKey}/kb`);

});
parcelRegister("5UrQm", function(module, exports) {

$parcel$export(module.exports, "fetchUserCapabilities", () => $d922b59af20cbe71$export$d1eac56717011ed4);

var $2OdyW = parcelRequire("2OdyW");

const $d922b59af20cbe71$export$d1eac56717011ed4 = (projectId, activationId)=>{
    const url = `${(0, $64356a5e39dcf909$export$f224912d4ec4705e)}/${activationId}/api/project/${projectId}/user/capabilities`;
    return (0, $2OdyW.default)(url, {
        method: 'GET'
    });
};

});



parcelRegister("eJinc", function(module, exports) {

$parcel$export(module.exports, "fetchDraftAndNavigateToEditor", () => $839a9144662af727$export$e8292dc9536b9de8);

var $bgrIS = parcelRequire("bgrIS");

var $jMP2a = parcelRequire("jMP2a");


var $gYTBU = parcelRequire("gYTBU");

var $jkMm4 = parcelRequire("jkMm4");

var $6JCoa = parcelRequire("6JCoa");
const $839a9144662af727$var$EVENT_NAME = 'createNewConfluencePage';
const $839a9144662af727$export$e8292dc9536b9de8 = ({ spaceKey: spaceKey, routerActions: routerActions, projectKey: projectKey, projectId: projectId, onCloseRedirectUrl: onCloseRedirectUrl = '', onPublishRedirectUrl: onPublishRedirectUrl = '', analyticsEvent: analyticsEvent, topicId: topicId, topicName: topicName })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        try {
            setState({
                ...getState(),
                isFetchingDraftDetails: true
            });
            const createContentParams = {
                spaceKey: spaceKey,
                parentProductContentContainerId: String(projectId),
                parentProduct: (0, $7c4208883f283a36$export$f6fc4a5779d5dc2c),
                title: topicName
            };
            const { contentId: contentId, draftShareId: draftShareId } = await (0, $bgrIS.createContent)(createContentParams);
            setState({
                ...getState(),
                articleId: contentId,
                draftShareId: draftShareId,
                isFetchingDraftDetails: false
            });
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${$839a9144662af727$var$EVENT_NAME} succedded`, {
                topicId: topicId
            });
            dispatch((0, $6JCoa.setRedirectionData)({
                onCloseRedirectUrl: onCloseRedirectUrl,
                onPublishRedirectUrl: onPublishRedirectUrl
            }));
            dispatch((0, $jkMm4.navigateCreateDraftRoute)({
                routerActions: routerActions,
                projectKey: projectKey,
                selectedSpaceKey: spaceKey
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                isFetchingDraftDetails: false,
                showConfluenceCreatePageError: true
            });
            (0, $gYTBU.fireErrorAnalyticsEvents)(error, $839a9144662af727$var$EVENT_NAME, 'knowledgeCommon');
        }
    };

});
parcelRegister("bgrIS", function(module, exports) {

$parcel$export(module.exports, "createContent", () => $c713a5698918f511$export$41c7a4cacf5bab80);
/**
 * This function would be used by Embedding product to create Confluence Content. Content created by this function will be tagged with "embedded" flag.
 * At the moment we only support creating a blank page and does not support cross domain request (Parent Product must be in same domain as Confluence)
 * To enable unlicensed user to create a page, parentProduct & parentProductContentContainerId are required.
 */ 
var $2GDCE = parcelRequire("2GDCE");
const $c713a5698918f511$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS = [
    'parentProduct',
    'parentProductContentContainerId',
    'spaceKey'
];
const $c713a5698918f511$export$4de094b68e927f31 = 'X-Atl-EmbeddablePage-EntityIDs';
const $c713a5698918f511$export$41c7a4cacf5bab80 = async ({ spaceKey: spaceKey, parentPageId: parentPageId, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, domain: domain = '', title: title, body: body })=>{
    const payload = {
        type: 'page',
        status: 'draft',
        metadata: {
            properties: {
                editor: {
                    value: 'v2'
                }
            },
            frontend: {
                embedded: true
            }
        },
        space: {
            key: spaceKey
        },
        title: title,
        body: body
    };
    if (parentPageId) payload.ancestors = [
        {
            id: parentPageId
        }
    ];
    const baseurl = domain ? `https://${domain}` : domain;
    const unlicensedAccessHeader = $c713a5698918f511$var$getUnlicensedAccessHeader({
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    });
    let response;
    try {
        response = await fetch(`${baseurl}/wiki/rest/api/content`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                credentials: 'include',
                ...unlicensedAccessHeader
            },
            body: JSON.stringify(payload)
        });
    } catch (e) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
        // Promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side else resolve
        throw new Error(`Network failure ${e}`);
    }
    const responseJson = await response.json();
    if (!response.ok) throw new (0, $2GDCE.CreateError)(`Status: ${responseJson.statusCode} Message: ${responseJson.message}`, responseJson.statusCode);
    return {
        draftShareId: $c713a5698918f511$var$getDraftShareId(responseJson),
        spaceKey: responseJson?.space?.key,
        contentId: responseJson?.id,
        status: responseJson?.status,
        subType: responseJson?.subType
    };
};
const $c713a5698918f511$var$getDraftShareId = (data)=>(data?._links?.editui || '').match(/draftShareId=(.*?)(#|&|$)/)?.[1] || undefined;
const $c713a5698918f511$var$getUnlicensedAccessHeader = ({ parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, spaceKey: spaceKey })=>{
    const headerValue = {
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    };
    const isValidHeader = $c713a5698918f511$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS.every((key)=>Boolean(headerValue[key]));
    return isValidHeader ? {
        [$c713a5698918f511$export$4de094b68e927f31]: JSON.stringify(headerValue)
    } : undefined;
};

});
parcelRegister("2GDCE", function(module, exports) {

$parcel$export(module.exports, "CreateError", () => $6bfe30688a197e5f$export$91ee1703d5a5ab8b);
class $6bfe30688a197e5f$export$91ee1703d5a5ab8b extends Error {
    constructor(message, statusCode){
        super(message);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("jkMm4", function(module, exports) {

$parcel$export(module.exports, "navigateCreateDraftRoute", () => $4f011fcbcd6932b4$export$4e7c7ad076f5f5fc);

var $1bhfb = parcelRequire("1bhfb");
const $4f011fcbcd6932b4$export$4e7c7ad076f5f5fc = ({ routerActions: routerActions, projectKey: projectKey, selectedSpaceKey: selectedSpaceKey })=>async ({ getState: getState })=>{
        const { articleId: articleId, draftShareId: draftShareId } = {
            ...getState()
        };
        const EDIT_DRAFT_ROUTE = (0, $1bhfb.getDraftEditUrl)(projectKey, selectedSpaceKey, articleId, draftShareId);
        routerActions.push(EDIT_DRAFT_ROUTE);
    };

});
parcelRegister("1bhfb", function(module, exports) {

$parcel$export(module.exports, "getDraftEditUrl", () => $fe7b03974b104214$export$5e8433ae3ce7c696);
$parcel$export(module.exports, "isDraftCreatedWithNCS", () => $fe7b03974b104214$export$fc0fa1dc4749f854);
$parcel$export(module.exports, "findCategory", () => $fe7b03974b104214$export$93e9d221203aed67);

const $fe7b03974b104214$export$5e8433ae3ce7c696 = (projectKey, selectedSpaceKey, articleId, draftShareId)=>`/jira/servicedesk/projects/${projectKey}/knowledge/space/${selectedSpaceKey}/articles/${articleId}/edit?draftShareId=${draftShareId}`;
const $fe7b03974b104214$export$fc0fa1dc4749f854 = (collabService)=>collabService === (0, $7c4208883f283a36$export$d42203c46ecda0b5);
const $fe7b03974b104214$export$93e9d221203aed67 = (categoriesData, categoryId)=>{
    if (categoriesData.categories) return categoriesData.categories.find((category)=>category.id === categoryId);
    return undefined;
};

});


parcelRegister("6JCoa", function(module, exports) {

$parcel$export(module.exports, "setRedirectionData", () => $6cc0f431c0671a7d$export$c026d4a8850c302d);
$parcel$export(module.exports, "resetRedirectionData", () => $6cc0f431c0671a7d$export$7c6d6762f8b5b4db);
const $6cc0f431c0671a7d$export$c026d4a8850c302d = (redirectionData)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            redirectionData: redirectionData
        });
    };
const $6cc0f431c0671a7d$export$7c6d6762f8b5b4db = ()=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            redirectionData: {
                onPublishRedirectUrl: '',
                onCloseRedirectUrl: ''
            }
        });
    };

});


parcelRegister("fbP9C", function(module, exports) {

$parcel$export(module.exports, "fetchLinkedSpaces", () => $0f85ca8e45536dac$export$1999596e4ea30c16);

var $2oPLp = parcelRequire("2oPLp");
const $0f85ca8e45536dac$export$1999596e4ea30c16 = (projectKey)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...initialState,
            linkedSpaces: {
                ...initialState.linkedSpaces,
                isLoading: true
            }
        });
        try {
            const response = await (0, $2oPLp.getLinkedSpaces)(projectKey);
            const linkedSpaces = response.map(({ spaceKey: spaceKey, spaceName: spaceName })=>({
                    spaceKey: spaceKey,
                    spaceName: spaceName
                }));
            setState({
                ...initialState,
                linkedSpaces: {
                    ...initialState.linkedSpaces,
                    isLoading: false,
                    data: linkedSpaces,
                    totalSize: linkedSpaces.length
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...initialState,
                linkedSpaces: {
                    ...initialState.linkedSpaces,
                    isLoading: false,
                    error: error
                }
            });
        }
    };

});

parcelRegister("4DLis", function(module, exports) {

$parcel$export(module.exports, "fetchUserCapabilities", () => $6636a7d4133ef87d$export$d1eac56717011ed4);

var $jMP2a = parcelRequire("jMP2a");

var $gYTBU = parcelRequire("gYTBU");

var $5UrQm = parcelRequire("5UrQm");
const $6636a7d4133ef87d$var$EVENT_NAME = 'fetchUserCapabilities';
const $6636a7d4133ef87d$export$d1eac56717011ed4 = (projectId, activationId, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const initialState = {
            ...getState()
        };
        setState({
            ...getState(),
            userCapabilities: {
                ...initialState.userCapabilities,
                isLoading: true
            }
        });
        try {
            const data = await (0, $5UrQm.fetchUserCapabilities)(projectId, activationId);
            setState({
                ...getState(),
                userCapabilities: {
                    ...initialState.userCapabilities,
                    isLoading: false,
                    data: data,
                    error: null
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${$6636a7d4133ef87d$var$EVENT_NAME} succeeded`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                userCapabilities: {
                    ...initialState.userCapabilities,
                    isLoading: false,
                    error: error
                }
            });
            (0, $gYTBU.fireErrorAnalyticsEvents)(error, `${$6636a7d4133ef87d$var$EVENT_NAME} failed`, 'knowledgeCommon');
        }
    };

});

parcelRegister("4z04Y", function(module, exports) {

$parcel$export(module.exports, "removeCommonFlag", () => $fa680682e599c742$export$a2af96a4f99f3900);
const $fa680682e599c742$export$a2af96a4f99f3900 = (flagId)=>async ({ getState: getState, setState: setState })=>{
        const { flags: currentFlags } = getState();
        const flags = currentFlags.filter(({ id: id })=>id !== flagId);
        setState({
            ...getState(),
            flags: flags
        });
    };

});

parcelRegister("hjVbJ", function(module, exports) {

$parcel$export(module.exports, "reorderCategories", () => $f400ba865c832467$export$32f957e287d37daa);

var $hTLlD = parcelRequire("hTLlD");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");


var $ek16G = parcelRequire("ek16G");

var $al24r = parcelRequire("al24r");
const $f400ba865c832467$export$cde74ed295a2b838 = (categories, fromIndex, toIndex)=>{
    const newCategories = [
        ...categories
    ];
    const movedItem = newCategories.splice(fromIndex, 1)[0];
    if (movedItem !== undefined) newCategories.splice(toIndex, 0, movedItem);
    return newCategories;
};
const $f400ba865c832467$export$32f957e287d37daa = (projectId, fromIndex, toIndex, analyticsEvent, activationId, onReorderMismatch, onReorderFailure)=>async ({ setState: setState, getState: getState })=>{
        const categoryToBeMovedId = getState().categoriesData.categories[fromIndex].id;
        const initiallyOrderedCategories = [
            ...getState().categoriesData.categories
        ];
        const newlyOrderedCategories = $f400ba865c832467$export$cde74ed295a2b838(getState().categoriesData.categories, fromIndex, toIndex);
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: newlyOrderedCategories
            }
        });
        try {
            const { categories: categories } = await (0, $al24r.orderCategories)({
                projectId: projectId,
                activationId: activationId,
                categories: [
                    {
                        categoryId: categoryToBeMovedId,
                        order: toIndex
                    }
                ]
            });
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'category reordered', {
                id: (0, $ek16G.categoryGuidToString)(categoryToBeMovedId)
            });
            const expectedCategoryIdOrder = newlyOrderedCategories.map((category)=>category.id);
            const actualCategoryIdOrder = categories.map((categoryResult)=>categoryResult.id);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(expectedCategoryIdOrder, actualCategoryIdOrder)) {
                // Something about the category information in apollo is different to our store
                // e.g. another user has reordered categories, added a category, deleted a category
                setState({
                    ...getState(),
                    categoriesData: {
                        ...getState().categoriesData,
                        categories: categories
                    }
                });
                onReorderMismatch();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'reorderCategories',
                    packageName: 'jiraServicedeskKnowledgeCommon',
                    teamName: (0, $7c4208883f283a36$export$d57b6b390e78d90f)
                },
                error: error
            });
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: [
                        ...initiallyOrderedCategories
                    ]
                }
            });
            onReorderFailure();
        }
    };

});
parcelRegister("al24r", function(module, exports) {

$parcel$export(module.exports, "orderCategories", () => $732f390e58c4260b$export$e90b3dc42a0ddf96);

var $2OdyW = parcelRequire("2OdyW");

const $732f390e58c4260b$export$e90b3dc42a0ddf96 = ({ projectId: projectId, activationId: activationId, categories: categories, apolloPath: apolloPath = (0, $64356a5e39dcf909$export$f224912d4ec4705e) })=>{
    const url = `${apolloPath}/${activationId}/api/project/${projectId}/category/order`;
    return (0, $2OdyW.default)(url, {
        method: 'PUT',
        body: JSON.stringify(categories)
    });
};

});


parcelRegister("3L3T8", function(module, exports) {

$parcel$export(module.exports, "resetDraftArticleData", () => $d794c4bfd5fba7a0$export$e4dbf2710e8c685d);
const $d794c4bfd5fba7a0$export$e4dbf2710e8c685d = (resetDelete)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            draftShareId: '',
            closed: false,
            published: false,
            showConfluenceCreatePageError: false,
            spaceKey: '',
            ...resetDelete && {
                deleted: false,
                articleId: ''
            }
        });
    };

});

parcelRegister("5Povy", function(module, exports) {

$parcel$export(module.exports, "updateCategorySuccess", () => $a60dfab94e5bd990$export$7d46e556893bba77);
const $a60dfab94e5bd990$export$7d46e556893bba77 = (updatedCategory)=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            categoriesData: {
                ...getState().categoriesData,
                categories: getState().categoriesData.categories.map((category)=>category.id === updatedCategory.id ? updatedCategory : category)
            }
        });
    };

});


parcelRegister("iTtA0", function(module, exports) {

$parcel$export(module.exports, "getDraftShareId", () => $84c9a1e3202ec797$export$f31b9480a5e4fdcf);
$parcel$export(module.exports, "getArticleId", () => $84c9a1e3202ec797$export$2d21c0faccc1d33f);
$parcel$export(module.exports, "getIsFetchingDraftDetails", () => $84c9a1e3202ec797$export$19d926b900e1c065);
$parcel$export(module.exports, "getRedirectionData", () => $84c9a1e3202ec797$export$fdde4bb390e025db);
$parcel$export(module.exports, "getPermittedSpaces", () => $84c9a1e3202ec797$export$4a419b2d3bb6a3fc);
$parcel$export(module.exports, "getLinkedSpaces", () => $84c9a1e3202ec797$export$b764c9ef97480a8e);
$parcel$export(module.exports, "getUserCapabilities", () => $84c9a1e3202ec797$export$f7db3ef62579b328);
$parcel$export(module.exports, "getCategoriesData", () => $84c9a1e3202ec797$export$b416461ac52d8504);
$parcel$export(module.exports, "getCreateCategoryData", () => $84c9a1e3202ec797$export$e0cf4a4b69bbc694);
$parcel$export(module.exports, "getCategory", () => $84c9a1e3202ec797$export$410364bbb673ddbc);
$parcel$export(module.exports, "getCommonFlags", () => $84c9a1e3202ec797$export$b94d9d28300025a9);
$parcel$export(module.exports, "getKnowledgeCommonFlags", () => $84c9a1e3202ec797$export$1a5b9662b382779c);

var $gYTBU = parcelRequire("gYTBU");

var $1bhfb = parcelRequire("1bhfb");
const $84c9a1e3202ec797$export$c9cab98530df1a79 = ({ published: published })=>published;
const $84c9a1e3202ec797$export$f31b9480a5e4fdcf = ({ draftShareId: draftShareId })=>draftShareId;
const $84c9a1e3202ec797$export$2d21c0faccc1d33f = ({ articleId: articleId })=>articleId;
const $84c9a1e3202ec797$export$19d926b900e1c065 = ({ isFetchingDraftDetails: isFetchingDraftDetails })=>isFetchingDraftDetails;
const $84c9a1e3202ec797$export$fdde4bb390e025db = (state)=>state.redirectionData;
const $84c9a1e3202ec797$export$4a419b2d3bb6a3fc = (state)=>state.spacesPermitted;
const $84c9a1e3202ec797$export$b764c9ef97480a8e = (state)=>state.linkedSpaces;
const $84c9a1e3202ec797$export$f7db3ef62579b328 = (state)=>state.userCapabilities;
const $84c9a1e3202ec797$export$b416461ac52d8504 = (state)=>state.categoriesData;
const $84c9a1e3202ec797$export$e0cf4a4b69bbc694 = (state)=>state.createCategoryData;
const $84c9a1e3202ec797$export$410364bbb673ddbc = (state, categoryId)=>(0, $1bhfb.findCategory)(state.categoriesData, categoryId);
const $84c9a1e3202ec797$export$b94d9d28300025a9 = ({ flags: flags })=>flags;
const $84c9a1e3202ec797$export$1a5b9662b382779c = (state, messages)=>(0, $gYTBU.getCommonFlagData)({
        ...state
    }, messages);

});


parcelRegister("aqS7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dfd8319730a1769$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $jPfP5 = parcelRequire("jPfP5");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6RF8c = parcelRequire("6RF8c");

var $69CbS = parcelRequire("69CbS");
const $1dfd8319730a1769$var$KnowledgeHubCreateCategoryStateless = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isSubmitting: isSubmitting = false, isDisabled: isDisabled = false, onChange: onChange, onClose: onClose, onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $69CbS.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6RF8c.default), {
        onChange: onChange,
        onSubmit: onSubmit,
        formError: formError,
        fieldErrors: fieldErrors,
        isDisabled: isSubmitting
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "primary",
        onClick: onSubmit,
        isLoading: isSubmitting,
        isDisabled: isDisabled
    }, formatMessage((0, $69CbS.default).createAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClose
    }, formatMessage((0, $69CbS.default).cancelAction)))));
};
var $1dfd8319730a1769$export$2e2bcd8739ae039 = $1dfd8319730a1769$var$KnowledgeHubCreateCategoryStateless;

});
parcelRegister("jPfP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $87fa35216d96bc0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $etqm0 = parcelRequire("etqm0");
// eslint-disable-next-line jira/react/no-class-components
class $87fa35216d96bc0f$var$ViewTracker extends (0, $eUqFw.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $87fa35216d96bc0f$var$ViewTrackerWithAnalytics = (0, $1ngde.default)({
    componentName: 'view-tracker'
})((0, $2jDha.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $etqm0.PAGE_EVENT_ACTION)
        }).fire()
})($87fa35216d96bc0f$var$ViewTracker));
var // without onMount={noop} it won't work, defaultProps won't help
// @ts-expect-error - TS2322 - Type '{ onMount: (...args: any[]) => void; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any> & WithContextProps, "key" | "analyticsContext"> & RefAttributes<...>'.
// eslint-disable-next-line jira/import/no-anonymous-default-export
$87fa35216d96bc0f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($87fa35216d96bc0f$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    });

});

parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});




parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("6RF8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de1fe0ae31be3bc$export$2e2bcd8739ae039);

var $eGI9v = parcelRequire("eGI9v");

var $dt8Gi = parcelRequire("dt8Gi");
var $5de1fe0ae31be3bc$export$2e2bcd8739ae039 = (0, $eGI9v.default)('form', {
    onSubmit: 'submitted'
})((0, $dt8Gi.default));

});
parcelRegister("dt8Gi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec6b672c63cea875$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");

var $lRvnl = parcelRequire("lRvnl");

var $xeS7R = parcelRequire("xeS7R");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $a2KtD = parcelRequire("a2KtD");

var $aEhLv = parcelRequire("aEhLv");
const $ec6b672c63cea875$var$CreateCategoryForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors, isDisabled: isDisabled = false, testId: testId } = props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createOnChangeHandlerForField = (field)=>(e)=>{
            props.onChange(field, e.currentTarget.value);
        };
    const errorMessage = (field)=>fieldErrors && !!fieldErrors[field] ? formatMessage(fieldErrors[field].message) : undefined;
    return(// @ts-expect-error - TS2322 - Type '{ children: (Element | undefined)[]; onSubmit: (e: SyntheticEvent<any, Event>) => void; disabled: boolean; }' is not assignable to type 'DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
        onSubmit: onSubmit,
        disabled: isDisabled
    }, formError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        testId: testId && `${testId}--section-message`
    }, formatMessage(formError.message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $aEhLv.default).helpText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        // @ts-expect-error - TS2322 - Type '{ children: ({ fieldProps }: { fieldProps: FieldProps<string, HTMLInputElement>; error?: string | undefined; valid: boolean; meta: Meta; }) => Element; error: string | undefined; label: string; isRequired: true; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
        error: errorMessage('name'),
        label: formatMessage((0, $aEhLv.default).nameFieldLabel),
        isRequired: true,
        name: "name"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2KtD.default), {
            error: errorMessage('name')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ...fieldProps,
            isRequired: true,
            autoComplete: "off",
            placeholder: formatMessage((0, $aEhLv.default).nameFieldPlaceholder),
            isInvalid: fieldErrors && !!fieldErrors.name,
            maxLength: 100,
            onChange: createOnChangeHandlerForField('name'),
            isDisabled: isDisabled,
            autoFocus: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        // @ts-expect-error - TS2322 - Type '{ children: ({ fieldProps }: { fieldProps: FieldProps<string, HTMLInputElement>; error?: string | undefined; valid: boolean; meta: Meta; }) => Element; error: string | undefined; label: string; isRequired: true; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
        error: errorMessage('description'),
        label: formatMessage((0, $aEhLv.default).descriptionFieldLabel),
        name: "description"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2KtD.default), {
            error: errorMessage('description')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
            ...fieldProps,
            maxLength: 150,
            minimumRows: 3,
            autoComplete: "off",
            placeholder: formatMessage((0, $aEhLv.default).descriptionFieldPlaceholder),
            isInvalid: fieldErrors && !!fieldErrors.description,
            isDisabled: isDisabled,
            onChange: createOnChangeHandlerForField('description')
        })))));
};
var $ec6b672c63cea875$export$2e2bcd8739ae039 = $ec6b672c63cea875$var$CreateCategoryForm;

});
parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "1v8a0r4",
    styles: "display:inline-block;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$var$oldFieldsetLabelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N200)})`,
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $7dbb02f7c217159b$var$newFieldsetLabelStyles = {
    name: "1btbeoi",
    styles: "color:var(--ds-text-subtle, #44546F);font-weight:var(--ds-font-weight-bold, 700)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ],
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ]
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R400)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("xeS7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe3143162b284fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $dkGpW = parcelRequire("dkGpW");
const $2fe3143162b284fd$var$packageName = "platform-pkg";
const $2fe3143162b284fd$var$packageVersion = "0.0.0-use.local";
const $2fe3143162b284fd$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $2fe3143162b284fd$var$packageName,
    packageVersion: $2fe3143162b284fd$var$packageVersion
};
const $2fe3143162b284fd$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $dkGpW.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $2fe3143162b284fd$var$InnerTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const ourRef = (0, $eUqFw.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eUqFw.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $eUqFw.useMemo)(()=>(0, $dkGpW.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $byn9U.css)([
        baseStyles,
        (0, $dkGpW.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $2fe3143162b284fd$var$TextArea = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($2fe3143162b284fd$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$2fe3143162b284fd$var$TextArea.displayName = 'TextArea';
var $2fe3143162b284fd$export$2e2bcd8739ae039 = $2fe3143162b284fd$var$TextArea;

});
parcelRegister("dkGpW", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $ffa47244c710aa2a$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $ffa47244c710aa2a$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $ffa47244c710aa2a$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9rnqv = parcelRequire("9rnqv");
function $ffa47244c710aa2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffa47244c710aa2a$var$disabledRules = {
    backgroundColor: $9rnqv.disabledBackground,
    backgroundColorFocus: $9rnqv.disabledBackground,
    backgroundColorHover: $9rnqv.disabledBackground,
    borderColor: $9rnqv.disabledBorder,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    textColor: $9rnqv.disabledTextColor
};
const $ffa47244c710aa2a$var$invalidRules = {
    borderColor: $9rnqv.invalidBorderColor,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    backgroundColor: $9rnqv.defaultBackgroundColor,
    backgroundColorFocus: $9rnqv.defaultBackgroundColorFocus,
    backgroundColorHover: $9rnqv.defaultBackgroundColorHover
};
const $ffa47244c710aa2a$var$backgroundColor = {
    standard: $9rnqv.defaultBackgroundColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorFocus = {
    standard: $9rnqv.defaultBackgroundColorFocus,
    subtle: $9rnqv.defaultBackgroundColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorHover = {
    standard: $9rnqv.defaultBackgroundColorHover,
    subtle: $9rnqv.defaultBackgroundColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColor = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorFocus = {
    standard: $9rnqv.defaultBorderColorFocus,
    subtle: $9rnqv.defaultBorderColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorHover = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.subtleBorderColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$lineHeightBase = 20;
const $ffa47244c710aa2a$var$lineHeightCompact = 16;
const $ffa47244c710aa2a$var$compactVerticalPadding = 2;
const $ffa47244c710aa2a$var$verticalPadding = 6;
const $ffa47244c710aa2a$var$horizontalPadding = 8;
const $ffa47244c710aa2a$var$transitionDuration = '0.2s';
const $ffa47244c710aa2a$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $ffa47244c710aa2a$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $ffa47244c710aa2a$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $ffa47244c710aa2a$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $ffa47244c710aa2a$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $ffa47244c710aa2a$var$lineHeightBase * minimumRows;
    return contentHeight + $ffa47244c710aa2a$var$verticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $ffa47244c710aa2a$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $ffa47244c710aa2a$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorFocus,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColor,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColor
            }
        } : {}
    });
const $ffa47244c710aa2a$var$placeholderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $ffa47244c710aa2a$var$disabledRules.textColor
    }
});
const $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
            }
        }
    });
var $ffa47244c710aa2a$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $ffa47244c710aa2a$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $ffa47244c710aa2a$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        resize: resize
    });
    if (resize === 'auto') return $ffa47244c710aa2a$var$_ref2;
    return $ffa47244c710aa2a$var$_ref;
};
const $ffa47244c710aa2a$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $ffa47244c710aa2a$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $ffa47244c710aa2a$var$codeFontFamily : $ffa47244c710aa2a$var$fontFamily
    });
const $ffa47244c710aa2a$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $ffa47244c710aa2a$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightBase / 14
        }
    });
};
const $ffa47244c710aa2a$var$staticStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out,
               border-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$ffa47244c710aa2a$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $ffa47244c710aa2a$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $ffa47244c710aa2a$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $ffa47244c710aa2a$var$disabledRules.textColor
        }
    });

});
parcelRegister("9rnqv", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f5064939140dcbf4$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f5064939140dcbf4$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f5064939140dcbf4$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f5064939140dcbf4$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f5064939140dcbf4$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f5064939140dcbf4$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f5064939140dcbf4$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f5064939140dcbf4$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f5064939140dcbf4$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f5064939140dcbf4$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f5064939140dcbf4$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f5064939140dcbf4$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f5064939140dcbf4$export$f4d082c200a4b4b8);

var $PdmhA = parcelRequire("PdmhA");
const $f5064939140dcbf4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`;
const $f5064939140dcbf4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $PdmhA.N40)})`;
const $f5064939140dcbf4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $PdmhA.R400)})`;
const $f5064939140dcbf4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $PdmhA.N100)})`;
const $f5064939140dcbf4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $PdmhA.B200)})`;
const $f5064939140dcbf4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $PdmhA.N10)})`;
const $f5064939140dcbf4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`;
const $f5064939140dcbf4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`;
const $f5064939140dcbf4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f5064939140dcbf4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`;
const $f5064939140dcbf4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $PdmhA.N900)})`;
const $f5064939140dcbf4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $PdmhA.N70)})`;
const $f5064939140dcbf4$export$f4d082c200a4b4b8 = 'transparent';

});



parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

var $PdmhA = parcelRequire("PdmhA");
const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    subtle: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`,
                borderColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $PdmhA.R400})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $PdmhA.R400})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $PdmhA.N0})`,
            borderColor: `var(--ds-border-focused, ${0, $PdmhA.B200})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("a2KtD", function(module, exports) {

$parcel$export(module.exports, "default", () => $61937544c35ff5ed$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
function $61937544c35ff5ed$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($61937544c35ff5ed$var$ErrorMessage, null, props.error));
}
$61937544c35ff5ed$export$2e2bcd8739ae039.defaultProps = {
    error: undefined
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61937544c35ff5ed$var$ErrorMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1l5o _1yt4swc3",
            __cmplp.className
        ])
    });
});

});

parcelRegister("aEhLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb7936f14c6fcfe3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bb7936f14c6fcfe3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    helpText: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.help-text",
        "defaultMessage": "Group related articles in categories to help customers find what they need."
    },
    nameFieldLabel: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-label",
        "defaultMessage": "Name"
    },
    nameFieldPlaceholder: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-placeholder",
        "defaultMessage": "Category name, e.g \"Printers\" or \"Wifi\""
    },
    descriptionFieldLabel: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-label",
        "defaultMessage": "Description"
    },
    descriptionFieldPlaceholder: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-placeholder",
        "defaultMessage": "Tell customers more about this category"
    }
});

});



parcelRegister("69CbS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a0c00d4c49c53a2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8a0c00d4c49c53a2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.title",
        "defaultMessage": "Create new category"
    },
    createAction: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-action",
        "defaultMessage": "Create"
    },
    cancelAction: {
        "id": "servicedesk-knowledge-common.create-category.create-category-stateless.cancel-action",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("79HyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb3c5e185f4ca7fe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gpawh = parcelRequire("gpawh");
const $eb3c5e185f4ca7fe$var$NavDriver = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gpawh.KbCreateCategorySubscriber), null, ({ isOpen: isOpen }, { setCreateCategoryDisplay: setCreateCategoryDisplay })=>{
        const onClose = ()=>setCreateCategoryDisplay(false);
        return children({
            isOpen: isOpen,
            onClose: onClose
        });
    });
};
var $eb3c5e185f4ca7fe$export$2e2bcd8739ae039 = $eb3c5e185f4ca7fe$var$NavDriver;

});
parcelRegister("gpawh", function(module, exports) {

$parcel$export(module.exports, "useKbCreateCategoryActions", () => $58931ec53f6ca989$export$719df9e736f08a9);
$parcel$export(module.exports, "KbCreateCategorySubscriber", () => $58931ec53f6ca989$export$2b9cf8c256011b51);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $58931ec53f6ca989$export$d4c72bab9d6cc13a = {
    isOpen: false
};
const $58931ec53f6ca989$var$setCreateCategoryDisplay = (isOpen)=>({ setState: setState })=>{
        setState({
            isOpen: isOpen
        });
    };
const $58931ec53f6ca989$export$e324594224ef24da = {
    setCreateCategoryDisplay: $58931ec53f6ca989$var$setCreateCategoryDisplay
};
const $58931ec53f6ca989$var$Store = (0, $a61MH.createStore)({
    name: 'kb-create-category',
    initialState: $58931ec53f6ca989$export$d4c72bab9d6cc13a,
    actions: $58931ec53f6ca989$export$e324594224ef24da
});
const $58931ec53f6ca989$export$719df9e736f08a9 = (0, $ggKAj.createHook)($58931ec53f6ca989$var$Store, {
    selector: null
});
const $58931ec53f6ca989$export$2b9cf8c256011b51 = (0, $dYfll.createSubscriber)($58931ec53f6ca989$var$Store);

});



parcelRegister("3o0h6", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $d0c61d036d967c5f$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9c7gV = parcelRequire("9c7gV");
const $d0c61d036d967c5f$export$c59987a647e9a55 = ({ Page: Page, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0c61d036d967c5f$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Page, null, children));
$d0c61d036d967c5f$export$c59987a647e9a55.defaultProps = {
    Page: (0, $9c7gV.default)
};
var $d0c61d036d967c5f$export$2e2bcd8739ae039 = $d0c61d036d967c5f$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0c61d036d967c5f$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8zdiv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2RidI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3141fb0b4d3f9503$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $iVSJI = parcelRequire("iVSJI");

var $frZnw = parcelRequire("frZnw");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $1IzB8 = parcelRequire("1IzB8");
const $3141fb0b4d3f9503$var$ServiceDeskAppBase = ({ appName: appName, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IzB8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $frZnw.toPackageName)(appName),
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, children))));
var $3141fb0b4d3f9503$export$2e2bcd8739ae039 = $3141fb0b4d3f9503$var$ServiceDeskAppBase;

});
parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.subProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("1IzB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $edeca50de0b85084$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");


var $bsgfb = parcelRequire("bsgfb");

var $1fuiA = parcelRequire("1fuiA");
const $edeca50de0b85084$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $10fdS.useCurrentRoute)().path.includes(`${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const Gate = isSettingsRoute ? (0, $1fuiA.default) : (0, $bsgfb.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Gate, null, children);
};
var $edeca50de0b85084$export$2e2bcd8739ae039 = $edeca50de0b85084$var$AccessCheck;

});
const $2df94debed157361$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';

parcelRegister("bsgfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d02215a42a3332$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $fz8wa = parcelRequire("fz8wa");

var $11C4f = parcelRequire("11C4f");
const $a7d02215a42a3332$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $fz8wa.useApplicationPermissions)();
    const [projectKey = ''] = (0, $kJlBc.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11C4f.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: "/jira"
    });
};
var $a7d02215a42a3332$export$2e2bcd8739ae039 = $a7d02215a42a3332$var$ProductAccessCheck;

});
parcelRegister("11C4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2544b3bfea70255$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $jyTef = parcelRequire("jyTef");


var $6tW8V = parcelRequire("6tW8V");
const $a2544b3bfea70255$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $kJlBc.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $jyTef.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $6tW8V.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $a2544b3bfea70255$export$2e2bcd8739ae039 = $a2544b3bfea70255$var$AgentCheck;

});
parcelRegister("6tW8V", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $5107715f0b974007$export$ddaebe4928e793cb);

const $5107715f0b974007$var$RESTRICTED_ACCESS_CODES = [
    (0, $1c3fbb431a173cc6$export$a3269a3914b007e3),
    (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef),
    (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)
];
const $5107715f0b974007$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $5107715f0b974007$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});



parcelRegister("1fuiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0788b3e6146363c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2Ba2b = parcelRequire("2Ba2b");

var $jyTef = parcelRequire("jyTef");

var $6tW8V = parcelRequire("6tW8V");
const $0788b3e6146363c4$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $jyTef.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $6tW8V.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.ProjectNotFound), null);
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null);
    return null;
};
var $0788b3e6146363c4$export$2e2bcd8739ae039 = $0788b3e6146363c4$var$SettingsAccessCheck;

});
parcelRegister("2Ba2b", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $abcdf98f8a718d25$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $abcdf98f8a718d25$export$7d465be8efa67280);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $heNSb = parcelRequire("heNSb");

var $4Es8k = parcelRequire("4Es8k");

var $lQXqy = parcelRequire("lQXqy");

var $7QuzF = parcelRequire("7QuzF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $6Yj0X = parcelRequire("6Yj0X");
const $abcdf98f8a718d25$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $7QuzF.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).notFoundTitle),
        description: formatMessage((0, $6Yj0X.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
            to: projectsPath
        }, formatMessage((0, $6Yj0X.default).notFoundAction))
    }));
};
const $abcdf98f8a718d25$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $lQXqy.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).genericErrorTitle),
        description: formatMessage((0, $6Yj0X.default).genericErrorDescription)
    }));
};

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("lQXqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $30559913302f86cb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $30559913302f86cb$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("jhcOe")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6bGvz")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $9TZf5 = parcelRequire("9TZf5");

var $6bGvz = parcelRequire("6bGvz");

var $jhcOe = parcelRequire("jhcOe");
const $30559913302f86cb$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jhcOe)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6bGvz))
});
var $30559913302f86cb$export$2e2bcd8739ae039 = $30559913302f86cb$var$Illustration;
// for advanced use only
const $30559913302f86cb$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("6bGvz", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("jhcOe", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("7QuzF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab5059cf2dfabb6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $9TZf5 = parcelRequire("9TZf5");

var $h5DV7 = parcelRequire("h5DV7");
const $3ab5059cf2dfabb6$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($h5DV7)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h5DV7))
});
var $3ab5059cf2dfabb6$export$2e2bcd8739ae039 = $3ab5059cf2dfabb6$var$Illustration;
// for advanced use only
const $3ab5059cf2dfabb6$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("h5DV7", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("6Yj0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c13e1fbd282caae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c13e1fbd282caae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});





parcelRegister("2d7Sj", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $0653f34646647329$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $0653f34646647329$export$c7841d2c1c13065e);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $1ybV0 = parcelRequire("1ybV0");

var $heNSb = parcelRequire("heNSb");

var $giAhk = parcelRequire("giAhk");

var $f9Osc = parcelRequire("f9Osc");
const $0653f34646647329$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, intl: { formatMessage: formatMessage }, projectName: projectName, subsection: subsection } = props;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    const titleOld = `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    const titleNew = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${subsection} - ${formatMessage((0, $f9Osc.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    const title = (0, $1ybV0.ff)('a11y-fission-queues-related-issues_giuuk') ? titleNew : titleOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, {
        title: title
    });
};
const $0653f34646647329$var$InjectedPage = (0, $knPb9.default)($0653f34646647329$export$155581e8dc02007a, {
    DocumentTitle: (0, $heNSb.DocumentTitle)
});
const $0653f34646647329$export$c7841d2c1c13065e = (0, $giAhk.injectIntlV2)($0653f34646647329$var$InjectedPage);
var $0653f34646647329$export$2e2bcd8739ae039 = $0653f34646647329$export$c7841d2c1c13065e;

});
parcelRegister("f9Osc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be746c19c254767$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7be746c19c254767$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    }
});

});



parcelRegister("fgAHK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('dvgCI')
        ]);
        const value = parcelRequire('lOwKX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("dvgCI")
    ]).then(()=>parcelRequire('lOwKX'));
}

});



//# sourceMappingURL=async-servicedesk-knowledge-hub-category.ce30bbcf.js.map
